export default {
  id: "بطاقة تعريف",
  dashboard: "لوحة القيادة'",
  warning: "تحذير",
  users: "المستخدمين ",
  farms: "المزارع ",
  animals: "الحيوانات'",
  action: "فعل'",
  actionList: "قائمة الإجراءات ",
  drugInventory: "مخزون المخدرات ",
  inseminatorStatistics: "إحصاءات اللوحات ",
  organizationNTR: "منظمة ntr ",
  genotypePerformance: "أداء النمط الوراثي ",
  semenAutomation: "أتمتة السائل المنوي ",
  activityLogs: "سجل النشاطات'",
  username: "اسم المستخدم",
  title: "عنوان",
  deactivated: "إلغاء تنشيطه ",
  name: "اسم'",
  email: "بريد إلكتروني'",
  emailAddress: "عنوان البريد الإلكتروني'",
  mobileNum: "رقم الهاتف المحمول'",
  emailOrMobile:"البريد الإلكتروني / الجوال",
  role: "دور'",
  roles: "أدوار ",
  department: "قسم'",
  status: "حالة'",
  pages: "الصفحات ",
  departments: "الإدارات ",
  password: "كلمة المرور'",
  cancel: "يلغي",
  submit: "يُقدِّم",
  error: "خطأ'",
  success: "نجاح'",
  Browse: "تصفح",
  orDropYourFileCsvXlsXlsxHere: "أو إسقاط ملفك (CSV  XLS  XLSX) هنا ",
  search: "يبحث",
  apply: "يتقدم",
  select: "يختار",
  previous: "سابق",
  mandatory: "إلزامي",
  dropYourFileHere: "أو إسقاط ملفك (CSV  XLS  XLSX  PDF  DOCX  PNG  JPEG) هنا ",
  restoreDefault: "استعادة الافتراضي",
  pending: "قيد الانتظار",
  completed: "مكتمل",
  remove: "يزيل",
  update: "تحديث",
  removeFile: "إزالة الملف",
  uploadFile: "رفع ملف",
  pleaseChoosePreferedLanguage: "الرجاء اختيار لغتك المفضلة ",
  edit: "يحرر",
  activate: "تفعيل",
  deactivate: "إلغاء تنشيط ",
  recievedOrders: "أوامر مستلم ",
  chartRepresentation: "تمثيل المخطط ",
  nameIsRequired: "مطلوب اسم",
  export: "يصدّر",
  noFilesAvailable: "لا توجد ملفات متوفرة ",
  selectDepartmentToshowRoles: "حدد قسمًا لإظهار الأدوار ",
  selectDepartmentWithActiveRoles: "حدد قسمًا بأدوار نشطة ",
  nameCanContainOnlyAlphabets: "يمكن أن يحتوي الاسم على الحروف الفضائية فقط ",
  nameMustBeLessThan15Chars: "يجب أن يكون الاسم أقل من 30 حرفًا ",
  emailRequired: "البريد الالكتروني مطلوب",
  invalidEmailFormat: "تنسيق بريد إلكتروني غير صالح ",
  mobNumReq: "رقم الهاتف المحمول مطلوب ",
  invalidMobFormat: "تنسيق رقم الهاتف المحمول غير صالح ",
  passwordRequired: "كلمة المرور مطلوبة",
  departmentReq: "القسم مطلوب ",
  roleReq: "الدور مطلوب ",
  unableToUpdate: "غير قادر على التحديث ",
  orignalName: "الاسم الاصلي",
  uploadedDate: "تاريخ التحميل ",
  fileName: "اسم الملف",
  importNum: "رقم الاستيراد ",
  languagePreferences: "تفضيل اللغات",
  pleaseTryAgainAfterSometime: "يرجى المحاولة بعد مرور بعض الوقت",
  noChanges: "لا تغيرات",
  nothingchanged: "لا شيء تغير",
  pleaseChooseAnImageFile: "الرجاء اختيار ملف صورة ",
  fileIsTooBigSelectUnder1MB:
    "ملفك كبير جدًا! الرجاء تحديد صورة تحت 1 ميجابايت ",
  phoneShouldHave10Chars: "يجب أن يحتوي الهاتف على 10 أحرف ",
  onlyCSVAllowed: "يسمح فقط ملف CSV ",
  loadingPleaseWait: "جاري التحميل الرجاءالانتظار",
  manager: "مدير",
  administrator: "مدير",
  Comingsoon: "قريباً",
  totalAnimals: "إجمالي الحيوانات ",
  receivedOrders: "تلقى أوامر ",
  drugs: "المخدرات",
  detailedAnalysis: "تحليل تفصيلي",
  barGraphRepOfActiveUsersAndDeactivateUsers:
    "تمثيل الرسم البياني الشريطي للمستخدمين النشطين والمستخدمين الذين يعانون من إلغاء الاطلاع ",
  barGraphRepOfRegAnimalsVsFarm:
    "تمثيل الرسم البياني الشريط للحيوانات المسجلة مقابل المزرعة ",
  roleNumber: "رقم الدور ",
  roleName: "اسم الدور'",
  active: "نشيط",
  inactive: "غير نشط",
  admin: "مسؤل",
  addRole: "أضف دورًا ",
  addRoles: "إضافة أدوار ",
  permissions: "أذونات ",
  sr: "ريال سعودى.",
  moduleName: "اسم وحدة",
  view: "منظر",
  deptNo: "رقم قسم ",
  selectByCategory: "حدد حسب الفئة ",
  weeklyAnalytics: "التحليلات الأسبوعية ",
  pregnancy: "حمل",
  analytics: "التحليلات ",
  calendar: "تقويم",
  productName: "اسم المنتج",
  volumeSold: "تباع الحجم ",
  recordPoints: "نقاط قياسية ",
  inStock: "في الأوراق المالية",
  revenue: "ربح",
  stockStatus: "حالة الرصيد وضع مخزون",
  barChart: "شريط الرسم البياني",
  lineChart: "خط الرسم البياني",
  indexReturns: "إرجاع الفهرس ",
  chart: "جدول",
  time: "وقت",
  production: "إنتاج",
  customization: "التخصيص ",
  recordsPerPage: "تسجيلات لكل صفحة",
  noDataAvailable: "لا تتوافر بيانات",
  reporting: "الإبلاغ ",
  optional: "خياري'",
  note: "ملحوظة'",
  notes: "ملحوظات'",
  date: "تاريخ'",
  kG: "كلغ'",
  weight: "وزن'",
  type: "يكتب'",
  lessthan3Month: "<3 أشهر ",
  lessthan6Month: "<6 أشهر ",
  lessthan7Month: "<7 أشهر ",
  lastWeek: "الأسبوع الماضي",
  thisWeek: "هذا الاسبوع",
  lessthanOneYear: "<1 سنة ",
  lessthanTwoYear: "<2 سنة ",
  lessthanThreeYear: "<3 سنوات ",
  lessthanFourYear: "<4 سنوات ",
  yes: "نعم",
  no: "لا",
  of: "ل'",
  notSpecified: "غير محدد",
  days: "أيام'",
  day: "يوم'",
  aDay: "يوم'",
  years: "سنين'",
  year: "سنة'",
  unit: "وحدة'",
  units: "الوحدات ",
  to: "ل'",
  profile: "حساب تعريفي'",
  logOut: "تسجيل خروج'",
  Unit: "وحدة'",
  otherSettings:"اعدادات اخرى",
  somethingWentWrong: "هناك خطأ ما.'",
  toDo: "لكى يفعل'",
  loadingData: "تحميل البيانات...'",
  taskNumber: "رقم المهمة ",
  taskName: "اسم المهمة'",
  startDate: "تاريخ البدء'",
  dueDate: "تاريخ الاستحقاق'",
  reason: "سبب'",
  quantity: "كمية",
  cost: "يكلف",
  noRecordFound: "لا يوجد سجلات'",
  dailyUpdates: "التحديثات اليومية ",
  weeklyUpdates: "التحديثات الأسبوعية ",
  moduleAccessed: "تم الوصول إلى الوحدة النمطية ",
  typesOfAccess: "أنواع الوصول ",
  userId: "معرف المستخدم",
  lastLogin: "آخر تسجيل دخول",
  terminalID: "معرف الطرفية ",
  geographicalAccessPoint: "نقطة الوصول الجغرافية ",
  iPAddress: "عنوان IP ",
  fileAccessed: "تم الوصول إلى الملف ",
  functionAccessed: "تم الوصول إلى الوظيفة ",
  webPageURL: "url صفحة الويب ",
  accessType: "نوع الوصول ",
  unsuccessfulLoginAttempts: "محاولات تسجيل الدخول غير الناجحة ",
  customerAddress: "عنوان العميل ",
  orderdate: "تاريخ الطلب",
  postageDate: "تاريخ البريد ",
  postID: "بعد معرف",
  packingTechnician: "فني التعبئة ",
  packingTechnicia: "فني تغليف",
  packEdit: "تحرير الحزمة",
  batchNumber: "رقم الدفعة",
  collectionTechnician: "فني التجميع ",
  collectionTechnicia: "جمع تقنية ",
  preparationTechnicia: "تحضير تقنية ",
  preparationTechnician: "فني التحضير ",
  approvedManually: "تمت الموافقة عليه يدويًا ",
  researcher: "الباحث",
  dateOfApproval: "تاريخ الموافقة",
  approvalEdit: "تعديل الموافقة",
  searchByAllExceptDate: "ابحث من قبل الجميع باستثناء التاريخ ",
  approval: "موافقة",
  collection: "مجموعة",
  postage: "رسوم البريد",
  pack: "علية",
  straws: "قش ",
  createdAt: "أنشئت في",
  economicIndexValue: "قيمة المؤشر الاقتصادي ",
  latestCollectionDate: "آخر تاريخ التجميع ",
  locationId: "معرف الموقع ",
  lastUpdated: "آخر تحديث'",
  print: "مطبعة'",
  save: "يحفظ'",
  tax: "ضريبة'",
  phoneNo: "رقم الهاتف'",
  exportAsPDF: "التصدير كـ pdf '",
  statusUpdated: "تم تحديث الحالة ",
  statusNotUpdated: "الحالة لم يتم تحديثها ",
  inProgress: "في تَقَدم",
  assignedTo: "مخصص ل",
  taskId: "معرف المهمة ",
  createdDate: "تاريخ الإنشاء",
  sireID: "معرف الأب",
  numberOfAnimals: "عدد الحيوانات ",
  healthRecordSubmittedSuccess: "تم تقديم السجل الصحي بنجاح ",
  healthRecordSubmitted: "السجل الصحي المقدم. ",
  InseminationRecordSubmittedSuccesful: "تم تقديم سجل التلقيح بنجاح ",
  inseminationRecordSubmitted: "تم تقديم سجل التلقيح. ",
  actionListDailyTask: "قائمة الإجراءات - المهمة اليومية ",
  sinceLastYear: "منذ السنة الماضية",
  sinceLastQuarter: "منذ الربع الأخير ",
  sinceLastMonth: "منذ اخر شهر",
  sinceLastWeek: "منذ الأسبوع الماضي ",
  drugWithdrawPeriod: "فترة المخدرات ",
  diagnosisName: "اسم التشخيص ",
  animalWithNoGenetype:
    "هذا الحيوان ليس لديه أي بيانات نماذج وراثية مسجلة. انقر فوق الزر أدناه للتسجيل. ",
  nameOfPreviousOwner: "اسم المالك السابق ",
  avatarSize: "يجب أن يكون حجم الرمزية أقل من 1 ميغابايت!",
  testDestination: "وجهة اختبار ",
  animalNotAdded: "لم يضاف الحيوان ",
  registerationSuccessful: "التسجيل ناجح ",
  backToAnimalList: "العودة إلى قائمة الحيوانات ",
  addAnotherAnimal: "أضف حيوانًا آخر ",
  animalDetailsUpdated: "تم تحديث تفاصيل الحيوان بنجاح ",
  animalUpdatedSuccessfully: "تم تحديث الحيوان بنجاح ",
  animalNotUpdated: "حيوان لم يتم تحديثه ",
  notMember: "ليس عضوا؟",
  requestAccess: "طلب الدخول",
  typePassword: "الرجاء كتابة كلمة المرور. ",
  minChars: "الحد الأدنى 6 أحرف",
  typeConfirmPassword: "اكتب تأكيد كلمة المرور ",
  passConfig: "تأكيد كلمة المرور لا يتطابق. ",
  invalidEmailMobile: "تنسيق بريد إلكتروني غير صالح/جوال ",
  passwordNotEmpty: "لا يمكن أن تكون كلمة المرور فارغة",
  passwordLength: "لا يمكن أن تكون كلمة المرور أقل من 8 أحرف ",
  cityVillage: "المدينة / القرية ",
  districtRegion: "منطقة المنطقة",
  alreadyHaveAnAccount: "alreday لديك حساب؟ ",
  genetypeUpdated: "تم تحديث النمط الوراثي ",
  genetypeNotUpdated: "النمط الوراثي لم يتم تحديثه ",
  sellTrade: "البيع/التجارة ",
  milkingDevon: "حلب Devon Breeding Stock للبيع ",
  detailedDescription: "وصف مفصل ",
  longPara:
    "الحلب الأمريكي ديفون الثيران العجول والأبقار. جميعها مسجلة الأصيلة. حيواناتنا اجتماعيًا جيدًا  وترعرعت فقط على العشب والقش والكثير من الحب. هذه الحيوانات الجميلة عبارة عن سلالة نادرة للأغراض الحليب واللحوم. A-1-A2 و A-2A-A2 الأسهم المتاحة. يرجى الاتصال أو البريد الإلكتروني لمزيد من المعلومات أو لترتيب قطيع",
  contactSeller: "تواصل مع البائع",
  enterListingTitle: "أدخل عنوان القائمة ",
  livestocktype: "نوع الماشية ",
  uploadImage: "تحميل صورة",
  mobilePhone: "رقم الهاتف الجوال",
  myLivestock: "ماشيك ",
  livestockObservations: "ملاحظات الماشية ",
  selectFromRegisteredAnimals: "اختر من قائمة الحيوانات المسجلة ",
  selectOption: "حدد الخيار ",
  selectTypeObservation: "حدد نوع الملاحظة ",
  attachVeteinaryDocument: "إرفاق الوثيقة البيطرية ",
  addsensorReading: "أضف قراءة المستشعر ",
  myDocument: "مستنداتي",
  enterAKeyword: "أدخل كلمة رئيسية",
  documentType: "نوع الوثيقة",
  registerEditLivestock: "تسجيل/تحرير الماشية ",
  editLivestockProfile: "تحرير ملف الثروة الحيوانية ",
  copy: "ينسخ",
  dateOfRegister: "تاريخ التسجيل ",
  livestockType: "نوع الماشية ",
  registerNewLivestock: "تسجيل الماشية الجديدة ",
  enterUniqueTag: "أدخل علامة فريدة #",
  color: "لون",
  gender: "جنس",
  male: "ذكر",
  female: "أنثى",
  damm: "سد #",
  siree: "sire #",
  dateOfSaleAuction: "تاريخ البيع/بيع المزاد ",
  auctionRecord: "سجل المزاد في قائمة الإعدام ",
  distinguishingFeatures: "السمات المميزة",
  keywordListing: "الكلمة الرئيسية أو معرف الإدراج ",
  adType: "نوع الإعلان ",
  activeListingFund: "تم العثور على قائمة نشطة ",
  setupSensors: "إعداد أجهزة استشعار ",
  serialNumber: "رقم سري",
  sensorLocation: "موقع المستشعر ",
  sensorType: "نوع الاستشعار",
  installationDate: "تاريخ التثبيت",
  ExpirationDate: "تاريخ انتهاء الصلاحية",
  addGeo: "أضف الموقع الجغرافي ",
  addMoreSensors: "أضف المزيد من المستشعرات ",
  trackAndTrace: "المسار والتتبع",
  createNewShipment: "إنشاء شحنة جديدة ",
  workflowReference: "مرجع سير العمل ",
  invoiceDate: "تاريخ الفاتورة ",
  trackShipment: "شحنة المسار",
  totalShipments: "إجمالي الشحنات ",
  activeShipment: "شحنات نشطة ",
  completedObjectives: "الأهداف المكتملة ",
  processedPayments: "المدفوعات المصنعة ",
  pointOfDestination: "نقطة المقصد ",
  sellerInformation: "معلومات البائع ",
  selectSellerConsignor: "حدد البائع/المرسل ",
  pointOfOrigin: "نقطة الاصل",
  buyerInfo: "معلومات المشتري ",
  selectBuyerConsignor: "حدد المشتري/المرسل ",
  addSensorTriggers: "إضافة مشغلات المستشعر ",
  processPayments: "مدفوعات العملية ",
  defineShippingContract: "تحديد عقد الشحن ",
  addDigitize: "إضافة ورقمنة المستندات ",
  currentlyOnFarm: "حاليا في المزرعة ",
  addSire: "أضف المولى ",
  addApproval: "أضف موافقة ",
  addCollection: "أضف مجموعة ",
  addStraws: "أضف قش ",
  addPack: "أضف حزمة ",
  addPostage: "أضف البريد ",
  searchBySire: "البحث عن طريق sire ",
  anyDataChangeMightBeLost: "قد تضيع أي تغييرات في البيانات ",
  wouldYouLikeToSaveOrWantToLeaveWithoutSaving:
    "هل ترغب في حفظ أو تريد المغادرة دون حفظ ",
  leave: "يترك",
  stay: "يقضي",
  animalFarm: "مزرعة الحيوانات",
  animalFarmH: "مزرعة الحيوانات",
  animalOrigin: "أصل حيواني",
  animalOriginH: "أصل حيواني",
  farmOfOrigin: "مزرعة المنشأ",
  farmOfOriginH: "مزرعة المنشأ",
  selectFarm: "حدد مزرعة",
  searchFarm: "بحث المزرعة",
  confirmation: "تأكيد",
  proceed: "يتابع",
  ok: "نعم",
  animal: {
    tagH: "بطاقة شعار",
    tagNumberH:
      "رقم العلامة: يمكنك إضافة اللون وكذلك الرقم. لا يقتصر على الأرقام فقط. ",
    goveRegNoH:
      "تفاصيل الهوية التي قد تتضمن اسم الفرد وعنوانه  وكيل الفرد لخدمة العملية  وموقع النشاط المراد تنفيذه  ووصف للخدمة التي يقدمها الفرد.    ",
    birthWeightH: "وزن ميلاد العجل ",
    birthEaseH:
      "الولادة في الماشية هي عملية طبيعية ولكن في بعض الأحيان يمكن أن تكون هناك مشاكل في الولادة حيث يحتاج السد إلى مساعدة من المزارع/الرعوية.",
    birthFarmH: "مزرعة الولادة ",
    surrogateDamH: "معرف السد تم استخدام الجنين ",
    ownerH: "هذا هو اسم مالك الحيوان. ",
    damH: "معرف سد الحيوان ",
    sireH: "معرف مولى الحيوان. ",
    breedH: "هذا هو سلالة من الحيوان. ",
    conceptionMethodH: "كيف تم تصور الحيوان. ",
    genderH: "جنس الحيوان. ",
    dobH: "تاريخ ميلاد الحيوان. ",
    operatorH: "اسم الشخص الذي يملأ معلومات هذا الحيوان ",
    removalFarmH: "المزرعة التي تمت إزالة الحيوانات ",
    dateOfRemovalH: "تاريخ إزالة الحيوانات ",
    destinationOfRemoval: "مكان الوجهة للحيوان الذي تمت إزالته ",
    reasonOfRemovalH: "سبب إزالة الحيوانات ",
    trackingNumberH: "الرقم المخصص للحيوان عند إزالة الحيوان ",
    brandH: "علامة تجارية تمييضًا وهي علامة دائمة تم إحراقها على البقرة. ",
    tattoH: "الوشم على الحيوانات. ",
    hornStatusH: "ما إذا كان الحيوان مبلل. ",
    animalOriginH: "بلد المنشأ للحيوان ",
    previousOwnerH: "اسم المالك السابق للحيوان في حال كان ناضجًا ",
    twinH: "هذا المجال يقول ما إذا كان الحيوان لديه توأم أم لا.",
    regBreedAssoNoH: "التسجيل مع جمعيات/مجتمعات السلالات ",
    breedAssoNameH: "اسم الجمعيات/المجتمعات حيث تم تسجيل الحيوان ",
    breederH: "هذا هو اسم المنظمة التي زودت الحيوان. ",
    noteH: "ملاحظة (ملاحظات) مهمة حول الحيوان. ",
    accuracyWeight_for_field: "دقة الوزن ",
    conception: "تصور'",
    addAnAnimal: "أضف حيوانًا ",
    addAnimal: "أضف حيوانًا ",
    registerAnAnimal: "تسجيل حيوان ",
    uploadAnAnimal: "تحميل حيوان ",
    animalRegistration: "تسجيل الحيوانات ",
    animalDetails: "تفاصيل الحيوان ",
    tag: "بطاقة شعار",
    tagNumber: "رقم العلامة ",
    govtRegNumber: "الحكومة. رقم التسجيل",
    birthWeight: "الوزن عند الولادة",
    birthEase: "سهولة الولادة ",
    birthFarm: "مزرعة الولادة ",
    surrogateDam: "سد بديل ",
    owner: "مالك",
    ownershipType: "نوع الملكية",
    animalDiseaseRecord: "AnimalDiseAserecord ",
    govtReg: "الحكومة. ريج ",
    regDate: "تاريخ ريج ",
    dam: "سد'",
    sire: "مولى",
    heifer: "العجلة ",
    steer: "توجيه ",
    calf: "عجل",
    farmHerd: "المزرعة/القطيع ",
    femaleCalf: "عجل أنثى ",
    maleCalf: "عجل الذكور ",
    newCalves: "عجول جديدة ",
    breed: "تكاثر",
    conceptionMethod: "طريقة التصور ",
    gender: "جنس",
    dateOfBirth: "تاريخ الميلاد",
    operator: "المشغل أو العامل",
    animalRemovedFarm: "المزرعة التي تمت إزالة الحيوانات ",
    dateOfAnimalRemoval: "تاريخ إزالة الحيوانات ",
    destinationOfRemovedAnimal: "وجهة الحيوانات التي تمت إزالتها ",
    reasonOfRemoval: "سبب الإزالة ",
    optionalAnimalInformation: "معلومات حيوان اختيارية ",
    animalPicture: "صورة الحيوان ",
    trackingNumber: "عدد تتبع'",
    brand: "ماركة'",
    tatto: "وشم'",
    hornStatus: "وضع القرن ",
    animalOrigin: "أصل حيواني'",
    previosOwner: "مالك Previos ",
    twin: "التوأم'",
    InABreedAssociation: "ريج. # في جمعية السلالات ",
    nameOfBreedAssociations: "اسم جمعيات السلالات ",
    breedAssociations: "جمعيات السلالات ",
    breederSupplier: "مربي (مورد) '",
    importAnimal: "استيراد حيوان ",
    loadingAnimals: "تحميل الحيوانات ... من فضلك انتظر ",
    totalRegAnimals: "مجموع ريج. الحيوانات",
    totalPregnantAnimals: "إجمالي الحيوانات الحامل ",
    pregnantAnimalHistory: "تاريخ الحيوان الحامل ",
    dailyAnimalPregnancyUpdates: "تحديثات حمل الحيوانات اليومية ",
    animalHistory: "تاريخ الحيوان ",
    dailyAnimalUpdates: "تحديثات الحيوانات اليومية ",
    totalPregnant: "الحامل الكلي ",
    totalNewBorn: "المولود الجديد ",
    searchByIDGOVRegTag: "ابحث عن طريق ID و GOV Reg و TAG ",
    noANIMALAVAILABLE: "لا حيوان متاح ",
    associationNumber: "رقم الرابطة ",
    destinationName: "اسم الوجهة",
    plastic: "بلاستيك'",
    metal: "معدن'",
    naturalMating: "التزاوج الطبيعي ",
    artificialInsemination: "التلقيح الاصطناعي'",
    embryoTransfer: "نقل الأجنة'",
    noAssistance: "لا مساعدة ",
    someAssistance: "بعض المساعدة ",
    mechanicalAssistance: "المساعدة الميكانيكية ",
    aCesareanSection: "قسم قيصري ",
    abnormalDelivery: "توصيل غير طبيعي ",
    male: "ذكر'",
    female: "أنثى'",
    sale: "أُوكَازيُون'",
    slaughter: "ذبح'",
    death: "موت'",
    theft: "سرقة'",
    other: "آخر'",
    horned: "قرنية ",
    polled: "استطلاع ",
    dehorned: "dehorned ",
    details: "تفاصيل'",
    performance: "أداء'",
    geneticWorth: "القيمة الوراثية ",
    healthRecord: "السجل الصحي'",
    genotypeData: "بيانات النمط الوراثي ",
    reminders: "تذكير ",
    activityLog: "سجل النشاطات'",
    activityLogDetails: "تفاصيل سجل النشاط '",
    editAnimal: "تحرير الحيوان ",
    familyInfo: "معلومات العائلة ",
    breedInfo: "معلومات تولد ",
    identification: "تعريف'",
    removalInfo: "معلومات الإزالة ",
    iDOfAnimalDam: "معرف سد الحيوان ",
    iDOfAnimalSire: "معرف مولى الحيوان. ",
    iDOfDamEmbryoUsed: "معرف السد تم استخدام الجنين Whos. ",
    animalHasATwinOrNot: "سواء كان الحيوان لديه توأم أم لا. ",
    breedType: "نوع السلالة ",
    breedOfTheAnimal: "هذا سلالة من الحيوان.",
    regBreedAssociations: "التسجيل مع جمعيات/ جمعيات السلالات. ",
    nameOfAssociationsSocieties:
      "اسم الجمعيات/المجتمعات حيث تم تسجيل الحيوان. ",
    nameOfTheOrgSuppliedAnimal: "هذا هو اسم المنظمة التي زودت الحيوان ",
    countryOriginAnimal: "بلد المنشأ للحيوان. ",
    birthFarmID: "معرف مزرعة الولادة ",
    farmIDAnimalBorn: "معرف المزرعة حيث ولد الحيوان.",
    currentOwner: "المالك الحالي'",
    nameOfOwnerAnimal: "هذا هو اسم مالك الحيوان. ",
    registrationDate: "تاريخ التسجيل'",
    previousOwner: "المالك السابق'",
    nameOfOperator: "اسم المشغل ",
    dateAnimalRemoved: "التاريخ عند إزالة الحيوان. ",
    destinationPlaceRemovedAnimal: "مكان الوجهة للحيوان الذي تمت إزالته ",
    namePersonFillAnimalInformation: "اسم الشخص الذي يملأ معلومات هذا الحيوان ",
    reasonOfAnimalRemoval: "سبب إزالة الحيوانات ",
    reasonWhyTheAnimalIsRemoved: "سبب إزالة الحيوان ",
    processingDate: "تاريخ المعالجة'",
    DateInformationFilledChanged:
      "التاريخ الذي تم فيه ملء المعلومات الحالية أو تغييرها. ",
    animalID: "معرف الحيوان ",
    UniqueIdAnimal: "هذا معرف فريد للحيوان. ",
    plasticTagNumber: "رقم العلامة البلاستيكية '",
    numberAnimalTag: "عدد العلامة الحيوانية. '",
    rFTagNumber: "رقم علامة RF '",
    numberAnimalRFTag: "عدد علامة RF الحيوان. '",
    govtRegNumb: "الحكومة. عدد ريج'",
    govtRegistrationNumber:
      "تفاصيل الهوية التي قد تتضمن اسم الفرد وعنوانه  وكيل الفرد لخدمة العملية  وموقع النشاط المراد تنفيذه  ووصف للخدمة التي يقدمها الفرد. ",
    numberAssignedAnimalIsRemoved:
      "رقم التتبع هو واحد من معرفات الحيوانات المستخدمة لتتبع النشاط الحيواني. ",
    dateOfAnimalRegistration: "تاريخ تسجيل الحيوانات ",
    stockBrandDesignSearedHideAnAnimalCattleColorCodeAnAnimal:
      "علامة تجارية تمييضًا تم إحراقها على البقرة. ",
    tattoOnAnimal: "الوشم على الحيوان. '",
    whetherTheAnimalIsDehorned: "ما إذا كان الحيوان مبلل. ",
    milkingAnimals: "حيوانات الحلب ",
    studAnimals: "حيوانات مسمار ",
    animalInseminationRecord: "سجل التلقيح الحيوان ",
    numOfStrawsOrdered: "عدد القش المطلوب ",
    totalNumOfStraws: "إجمالي عدد القش ",
    strawId: "معرف القش ",
    addSireAutomation: "أضف أتمتة sire ",
    addApprovalAutomation: "أضف أتمتة الموافقة ",
    addCollectionAutomation: "أضف أتمتة المجموعة ",
    addStrawsAutomation: "أضف أتمتة القش ",
    addPackAutomation: "أضف أتمتة الحزمة ",
    addPostageAutomation: "أضف أتمتة البريد ",
    searchBySire: "SearchBysire ",
    numberOfProgenies: "عدد السلالات ",
    sireEdit: "تحرير sire '",
    searchByStrawIdtotalNumbersOfStrawsBatchNumberAndLocation:
      "البحث عن طريق معرف القش  إجمالي الأرقام من القش ورقم الدفعة ومعرف الموقع ",
    searchByPackIdNumberOfStrawsOrderedPackingTechnicia:
      "ابحث عن طريق معرف الحزمة  وعدد القش المطلوب  وتكنولوجيا التعبئة ",
    searchByCollectionAndPreparationTechnicia:
      "ابحث عن طريق جمع التكنولوجيا والتحضير ",
    registerSemenAutomation: "تسجيل أتمتة السائل المنوي ",
    addSemenAutomation: "أضف أتمتة السائل المنوي ",
    strawAutomationRegistered: "مسجل أتمتة القش ",
    strawAutomationRegisteredNotRegistered: "أتمتة القش المسجلة غير مسجلة ",
    sireAutomationRegistered: "أتمتة المولى مسجلة ",
    sireAutomationNotRegistered: "أتمتة sire غير مسجلة ",
    postageAutomationIsRegistered: "تم تسجيل أتمتة البريد ",
    postageAutomationNotRegistered: "أتمتة البريد غير مسجل ",
    packAutomationIsRegistered: "أتمتة الحزمة مسجلة ",
    packAutomationNotRegistered: "أتمتة العبوة غير مسجلة ",
    postageAutomationIsUpdated: "يتم تحديث أتمتة البريد ",
    postageAutomationNotUpdated: "لم يتم تحديث أتمتة البريد ",
    packAutomationIsUpadted: "أتمتة الحزمة منتفخة ",
    packAutomationNotUpadted: "أتمتة حزمة غير مسببة ",
    collectionAutomationUpdated: "تم تحديث أتمتة جمع ",
    collectionAutomationNotUpdated: "لم يتم تحديث أتمتة جمع ",
    approvalAutomationIsUpdated: "يتم تحديث أتمتة الموافقة ",
    approvalAutomationIsNotUpdated: "لم يتم تحديث أتمتة الموافقة ",
    collectionAutomationRegistered: "جمع أتمتة المسجل ",
    collectionAutomationNotRegistered: "أتمتة جمع غير مسجلة ",
    approvalAutomationIsRegistered: "أتمتة الموافقة مسجلة ",
    approvalAutomationIsNotRegistered: "أتمتة الموافقة غير مسجلة ",
    strawAutomationUpdated: "تم تحديث أتمتة القش ",
    strawAutomationIsNotUpdated: "لم يتم تحديث أتمتة القش ",
    searchSire: "ابحث عن المولى ",
    performanceInfo: {
      milk: "لبن'",
      liveweight: "الوزن الحي ",
      score: "نتيجة'",
      fertility: "خصوبة'",
      measurements: "قياسات'",
      dailyProteinYield: "غلة البروتين اليومي ",
      amountProteinMilkCowDay:
        "كمية البروتين في الحليب التي تم الحصول عليها من بقرة في يوم معين. ",
      dailyMilkYield: "غلة الحليب اليومية ",
      volumeMilkCowDay:
        "حجم الحليب الذي تم الحصول عليه من بقرة معينة في يوم معين. ",
      dailyFatYield: "غلة الدهون اليومية ",
      amountFatMilkCowDay:
        "كمية الدهون في الحليب التي تم الحصول عليها من بقرة في يوم معين. ",
      dailyProteinContent: "محتوى البروتين اليومي ",
      dailyFatContent: "محتوى الدهون اليومي ",
      milkLactose: "اللاكتوز الحليب ",
      amountLactoseMilk: "كمية اللاكتوز في الحليب. ",
      milkUrea: "اليوريا الحليب ",
      indicatorAmountCrudeProtein:
        "مؤشر على كمية البروتين الخام في نظام غذائي بقرة ",
      lactationNumber: "رقم الرضاعة '",
      ordinalNumLactation: "العدد الترتيبي من الرضاعة. ",
      lengthOfLactation: "طول الرضاعة ",
      lactationLength: "طول الرضاعة (على سبيل المثال 23 يومًا) ",
      milkingFrequency: "تردد الحلب ",
      frequcnyOfMilking: "تواتر الحلب (على سبيل المثال 2 مرات في اليوم) ",
      currentWeight: "الوزن الحالي'",
      weightAnimal: "وزن الحيوان ",
      postWeaningGain: "ربح ما بعد الفطام ",
      dailyGainInAnimalWeightWeaning:
        "الربح اليومي في وزن الحيوان بعد الفطام. ",
      weaningWeight: "وزن الفطام ",
      weightAnimalMeasuredWeaning: "وزن الحيوانات المقاسة في يوم من الفطام. ",
      averageDailyGain: "متوسط ​​الربح اليومي ",
      averageAmountWeightAnimalGainFeedingPeriod:
        "متوسط ​​مقدار الوزن الذي سيحصل عليه حيوان كل يوم خلال فترة التغذية ",
      carcassWeight: "وزن الذبيحة ",
      weightAnimalsHideInternalOrgansRemoved:
        "تم إزالة وزن الحيوانات بعد الرأس  والاختباء والأعضاء الداخلية. ",
      weightAtCalving: "الوزن عند الولادة ",
      weightAtTheTimeOfCalving: "الوزن في وقت الولادة. ",
      yearlingWeight: "وزن الشاي ",
      weightYearOldAnimal: "وزن حيوان يبلغ من العمر سنة واحدة. ",
      somaticCellScore: "درجة الخلايا الجسدية ",
      somaticCellScoreIndicatorMastitis:
        "درجة الخلايا الجسدية كمؤشر لالتهاب الضرع. يمكن للمزارع اكتشاف العلامات المبكرة لعدوى التهاب الضرع باستخدام هذا الاختبار. SCC هو مقياس لخلايا الجسم وخلايا الدم البيضاء الموجودة في الحليب. تشير SCC العالية إلى وجود الالتهابات في ضرع البقرة. من المتوقع مستويات منخفضة من SCC (أقل من 200000/مل) لاستخراج البروتين الجيد من الحليب. ترتبط عدد الخلايا الجسدية بصحة ونظافة الأبقار ونظافة ظروف السكن. ",
      lastUpdate: "اخر تحديث'",
      bodyConditionScore: "درجة حالة الجسم ",
      scoreAnimalFat:
        "درجة من الحيوانات فيما يتعلق عدد الدهون التي لديها. تتراوح درجات الحالة من 1 (بقرة رقيقة جدًا بدون احتياطيات من الدهون) إلى 5 (بقرة مكيفة للغاية). درجات الحالة المثالية هي 3.0–3.25 في الجفاف والعجول  و 2.25-2.75 في ذروة الرضاعة  مع عدم وجود فئة من درجة الحالة المتغيرة بأبقار بأكثر من 0.5-0.75 خلال أي فترة رضاعة. '",
      teatScore: "درجة الحلمة ",
      scoreMeasureingShapeTeats:
        "درجات حجم الحلمة هي تقييمات ذاتية لطول الحلمة ومحيطها وتتراوح من 9 (صغيرة جدا) إلى 1 (كبيرة جدا). يجب أن تؤخذ درجات الضرع والرماء في غضون 24 ساعة بعد الولادة  ويفضل من قبل شخص واحد وفي ربع الأضعف. ",
      udderScore: "درجة تعليق الضرع '",
      scoreMeasureingShapeOfUdder:
        "درجة قياس شكل أودر (1-9 درجة). قوة ارتباط الصعود إلى البطن. كلما كانت تجويف الجسم أكثر إحكاما  تم وضع الضرع  كلما كان ذلك مرغوبًا فيه. هذا يسمح للعجل بتحديد موقع الحلمات بسهولة أكبر وأقل احتمالًا أن تسحب الحلمات في الوحل. ",
      whetherAnimalEasyBirthDifficult:
        "الولادة في الماشية هي عملية طبيعية ولكن في بعض الأحيان يمكن أن تكون هناك مشاكل في الولادة حيث يحتاج السد إلى مساعدة من المزارع/الرعوي. ",
      totalLongevity: "طول طول العمر ",
      survivalLactationTraitCowCulledBreeding:
        "البقاء من الأول إلى الخامس. يتم حساب هذه السمة بعد إعدام البقرة ويحتاج إلى تقدير قيمة التكاثر. ",
      docility: "انقياد'",
      circumferenceBullScrotal: "محيط كيس الصفن ",
      intervalSuccessInsemination:
        "الفاصل الزمني من الأول إلى التلقيح الناجح. ",
      ageAtFirstCalving: "العمر في الولادة الأولى ",
      ageCowCalving: "ما هو عصر البقرة في الولادة الأولى. ",
      calvingInterval: "فاصل العجول ",
      periodCalving: "الفترة من الولادة إلى الولادة التالية. ",
      scrotalCircumference: "محيط الصفن ",
      estrusDetection: "اكتشاف Estrus ",
      trackingBehaviorAnimalDetectingEstrus:
        "تتبع سلوك الحركة للحيوان للكشف عن شخرة بقرة. ",
      presenceOfEstrus: "وجود شروط ",
      isCowInEstrusStage: "هو عندما تكون البقرة على مرحلة الإستروس أو ولا '",
      matureWeight: "الوزن الناضج ",
      weightAnimalDefinedAge: "وزن حيوان في عصر محدد. ",
      matureHeight: "الارتفاع الناضج ",
      heightAnimalDefinedAge: "ارتفاع حيوان في العمر المحدد. ",
      footClawSet: "مجموعة مخلب القدم ",
      shapeAnimalClaw: "شكل مخلب الحيوان ",
      pulmonaryArterialPressure: "الضغط الشرياني الرئوي ",
      animalBloodPreasure: "دماء دماء الحيوانات. ",
      footAngle: "زاوية القدم ",
      shapeAnimalFoot: "شكل قدم الحيوان. ",
      ribEyeArea: "منطقة العين الضلع ",
      amountRibEyeArea: "كمية من منطقة العين الضلع. ",
      ultrasoundFat: "الدهون بالموجات فوق الصوتية ",
      measureFatAmount: "مقياس كمية الدهون. '",
      ultrasoundIntramuscularFat: "الموجات فوق الصوتية الدهون العضلية ",
      ultrasoundRibEyeArea: "منطقة الموجات فوق الصوتية للضلع ",
      measureRibeyeArea: "مقياس منطقة Ribeye. '",
      fatThickness: "سمك الدهون '",
      anmountAnimalBackFat: "anmount من الدهون الخلفية للحيوان ",
      marbling: "الرخام ",
      marballingMeasurement:
        "الرخام هو الدهون العضلية غير المشبعة (الصحية) المرئية التي تتراكم داخل العضلات وبين حزم الألياف العضلية. ",
      dryMatterIntake: "كمية الجافة ",
      amountFeedAnimalConsumesAMoisture:
        "كمية تغذية حيوان يستهلك يوميًا على أساس خالي من الرطوبة.",
    },
    feedsName: "اسم الأعلاف ",
    feedName: "أطعمنى'",
    firstFeedQuantity: "كمية التغذية الأولى ",
    additionalFeed: "تغذية إضافية ",
    cloversRyeGrasses: "البرسيم  أعشاب الجاودار ",
    greenFodderHayLegumes: "العلف الأخضر  القش  البقوليات ",
    feedsRegisteredSuccessfully: "الأعلاف المسجلة بنجاح ",
    feedsNotRegistered: "الأعلاف غير مسجلة ",
    fEEDQUANTITY: "كمية التغذية '",
    feedQuantity: "كمية التغذية '",
    fEEDNAME: "أطعمنى'",
    nOFEEDINFOAVAILABLE: "لا توجد معلومات تغذية متاحة ",
    searchByFeedName: "البحث عن طريق التغذية '",
    loadingFeedInfo: "تحميل معلومات التغذية ... يرجى الانتظار ",
    todayFeedInfo: "اليوم معلومات التغذية ",
    feedInfo: "معلومات التغذية ",
    loremIpsumDolorSitAmet:
      "lorem ipsum dolor sit amet  incectetur adipiscing leit. UT lacus sem  maximus interdum in  نتيجة غير SEM. Morbi Posuere Dignissim est ut molestie. '",
    geneticWorthInfo: {
      breedingValueEconomicIndex:
        "ما إذا كانت قيمة التكاثر هذه تستخدم لحساب المؤشر الاقتصادي. ",
      dailyProteinYieldUsed: "مستخدمة البروتين اليومي المستخدمة ",
      weightAssignedBreedingDailyProteinYield:
        "الوزن المعين لقيمة التكاثر المقابلة لـ محصول البروتين اليومي. يستخدم هذا الوزن لحساب المؤشر الاقتصادي. ",
      dailyProteinYieldWeight: "وزن البروتين اليومي ",
      rankAnimalInRelationshipEconomicIndex:
        "رتبة الحيوانات في العلاقة مع المؤشر الاقتصادي. ",
      economicIndexRank: "رتبة المؤشر الاقتصادي ",
      percentileEconomicIndexFall: "المئوية التي تنخفض فيها المؤشر الاقتصادي ",
      economicIndexPercentile: "مئوية المؤشر الاقتصادي ",
      accuracyOfEconomicIndex: "دقة المؤشر الاقتصادي ",
      economicIndexAccuracy: "دقة المؤشر الاقتصادي ",
      weightedAverageOfBreedingValues: "متوسط ​​مرجح لقيم التكاثر. ",
      economicIndex: "المؤشر الاقتصادي ",
      rankOfAnimalInRelationshipBreeding:
        "رتبة الحيوان في العلاقة مع قيمة التكاثر المقابلة. ",
      dailyProteinYieldBreedingValueRank: "ترتيب قيمة تربية البروتين اليومي ",
      percentileBreedingFalls: "المئوية التي تنخفض قيمة التكاثر. ",
      dailyProteinYieldBreedingPercentile:
        "قيمة البروتين اليومية عائد قيمة التكاثر ",
      accuracyEstimatedBreeding: "دقة قيمة التكاثر المقدرة. ",
      dailyProteinYieldBreedingAccuracy: "دقة قيمة البروتين اليومية دقة تربية ",
      estimatedBreedingTraitDailyProteinYield:
        "قيمة التكاثر المقدرة للسمات محصول البروتين اليومي.",
      dailyProteinYieldBreedingValue: "قيمة تربية البروتين اليومية ",
      pathToTheDirectoryScriptsBreeding:
        "المسار إلى الدليل على محرك الأقراص الثابتة التي تحتوي على برامج نصية تم استخدامها لحساب قيمة التكاثر. ",
      scriptsPath: "مسار البرامج النصية ",
      softwarePackageBreeding:
        "حزمة البرامج التي تم استخدامها لحساب قيمة التكاثر. ",
      breedingValueSoftware: "برنامج قيمة التكاثر ",
      methodCalculateBreeding: "الطريقة التي تم استخدامها لحساب التربية ",
      breedingValueMethod: "طريقة قيمة التكاثر ",
      trait: "سمة'",
      tools: "أدوات'",
      geneticWorth: "القيمة الوراثية ",
      dailyProteinYield: "غلة البروتين اليومي ",
      breedingValue: "قيمة التكاثر ",
      breedingValueBIFAccuracy: "دقة BIF قيمة التكاثر ",
      breedingValuePercentile: "قيمة التكاثر المئوية ",
      breedingValueRank: "ترتيب قيمة التكاثر ",
      checkLTD: "Check Ltd '",
      ultrasoundDiagnostic: "التشخيص بالموجات فوق الصوتية ",
      selectYieldUsed: "حدد العائد المستخدم ",
      softwareName: "اسم البرنامج ",
      animalGenWorthUpdatedSuccessfully:
        "تم تحديث وثيقة الجنرال الحيواني بنجاح ",
    },
    addNote: "اضف ملاحظة'",
    enterNote: "أدخل الملاحظة ",
    noteIsRequired: "ملاحظة مطلوبة ",
    noteMustBeLessThan50Characters: "يجب أن تكون الملاحظة أقل من 50 حرفًا ",
    noteAdded: "ملاحظة تمت إضافة '",
    noteNotAdded: "ملاحظة لم تتم إضافتها ",
    noteForAnimal: "ملاحظة للحيوان. '",
    noNoteFoundForThisAnimal: "لم يتم العثور على ملاحظة لهذا الحيوان. '",
    inseminationData: "بيانات التلقيح '",
    nameOfInseminator: "اسم inminator '",
    activity: "نشاط'",
    searchByNameActivity: "ابحث بالاسم  النشاط ",
    searchByTaskNameNumber: "ابحث حسب اسم المهمة  الرقم ",
    inseminationDate: "تاريخ التلقيح ",
    genotypeDataInfo: {
      genotypeAnimalID: "المعرف الوراثي للحيوان ",
      iDTubeBloodSampleAnimalNumberGenotypingService:
        "هذا هو معرف أنبوب مع عينة دم مأخوذة من الحيوان أو عدد من خدمة التنميط الجيني ",
      geneticTechnicianName: "اسم فني وراثي ",
      NameTechnicianBloodSamplesAnimal:
        "هذا هو اسم فني أخذ عينات من الدم من الحيوان ",
      sNPData: "بيانات SNP ",
      genotypingServiceNote: "ملاحظة خدمة التنميط الجيني ",
      InfoGenotypingGenotypingTechnology:
        "جميع المعلومات المتعلقة بالتنميط الجيني مثل اسم شركة التنميط الجيني  وتكنولوجيا التنميط الجيني المستخدمة  وتاريخ التنميط الوراثي  وما إلى ذلك ",
      numberOfSNPs: "عدد SNPs ",
      numberOfSNPsAnimalGenotyped: "عدد SNPs تم التنميط الوراثي لـ ",
      nameOfTheDrug: "اسم المخدرات ",
      animalGenoDataUpdatedSuccessfully: "تم تحديث بيانات Animal Geno بنجاح ",
      animalGenoDataNotUpdated: "لم يتم تحديث بيانات Animal Geno ",
      animalIDIsRequired: "مطلوب معرف الحيوان ",
      techNameIsRequired: "تقنية. مطلوب اسم'",
      onlyAlphabetsAreAllowed: "لا يُسمح سوى بالحرول الهجائي ",
      genoDataIsRequired: "بيانات GENO مطلوبة ",
      serviceNoteIsRequired: "ملاحظة الخدمة مطلوبة ",
      sNPIsRequired: "SNP مطلوب ",
    },
    healthRecordInfo: {
      treatment: "علاج'",
      treatmentTakenAnimal: "ما الذي تم اتخاذه على الحيوان. ",
      reasonOfTreatment: "سبب العلاج ",
      reasonForTreatment: "سبب العلاج ",
      whatReasonOfTreatment: "ما هو سبب العلاج.",
      treatmentDate: "تاريخ العلاج ",
      dateOfTreatment: "تاريخ العلاج. '",
      diagnosis: "تشخبص'",
      nameDiagnosedDiseaseConditionSymptoms:
        "اسم المرض/الحالة أو الأعراض الرئيسية ",
      drugID: "معرف المخدرات ",
      iDOfDrugWhichIsGivenToAnimal: "معرف الدواء الذي يعطى للحيوان. ",
      drugName: "اسم المخدرات ",
      nameDrugAnimal: "اسم الدواء الذي يعطى للحيوان. ",
      drugWithdrawalPeriod: "فترة انسحاب المخدرات ",
      timeAdministrationDrugAnimalMeatMilkHumanConsumption:
        "الوقت المطلوب بعد إعطاء دواء لحيوان لضمان سلامة اللحوم أو الحليب للاستهلاك البشري ",
      attendingVeterinarian: "حضور الطبيب البيطري ",
      qualifiedPersonCaseAnimal: "الشخص المؤهل الذي رأى القضية/الحيوان ",
      packID: "معرف الحزمة ",
      iDPackTreatment: "معرف حزمة تم استخدامها للعلاج ",
      veterinarianName: "الاسم البيطري ",
      animalNoHealthRecord:
        "هذا الحيوان ليس لديه أي سجل صحي. انقر فوق الزر أدناه للتسجيل ",
      addHealthRecord: "أضف سجلًا صحيًا ",
      healthStatus: "الحالة الصحية",
      loadingDiseasesPleaseWait: "تحميل الأمراض ... من فضلك انتظر ",
      animalDiseaseRecord: "سجل أمراض الحيوان ",
      animalHealthRecord: "سجل صحة الحيوان ",
      animalTreatmentRecord: "سجل علاج الحيوانات '",
      loadingHealthData: "تحميل البيانات الصحية ... ",
      healthRecord: "السجل الصحي",
      nameOfDiagnosis: "اسم التشخيص ",
      treatmentName: "اسم العلاج ",
      drugGivenBy: "المخدرات التي قدمها ",
      recessiveDiseases: "الأمراض المتنحية ",
    },
    conceptionInfo: {
      addNewConception: "أضف مفهومًا جديدًا ",
      semenEmbryo: "السائل المنوي/الجنين ",
      pregnancyCheck: "فحص الحمل ",
      birthInfo: "معلومات الولادة ",
      searchByInseminatorOrganisationBreedingConception:
        "ابحث عن طريق الاسم اللذيذ  اسم المنظمة  رقم خدمة التكاثر  طريقة الحمل ",
      deliveryDate: "تاريخ التسليم او الوصول'",
      calfId: "معرف العجل ",
      birthDayOldWeight: "الولادة (يوم) الوزن ",
      searchByBirthEase: "ابحث عن طريق الولادة سهولة ",
      searchPregnancyCheckOperatorMethod:
        "ابحث عن طريق مشغل فحص الحمل  طريقة فحص الحمل ",
      pregnancyCheckDate: "تاريخ فحص الحمل ",
      conceptionSuccess: "نجاح التصور '",
      pregnancyCheckOperator: "مشغل فحص الحمل ",
      pregnancyCheckMethod: "طريقة فحص الحمل ",
      recentlyPregnant: "حامل مؤخرًا ",
      pregnancyConfirmationDate: "تاريخ تأكيد الحمل ",
      pregnancyRate: "معدل الحمل ",
      timePeriodOfPregnancy: "الفترة الزمنية للحمل ",
      semenProduction: "إنتاج السائل المنوي ",
      embryoProduction: "إنتاج الجنين ",
      semen: "المني",
      embryoTransferDate: "تاريخ نقل الجنين ",
      daysOfPregnancy: "أيام الحمل ",
      searchSireEmbryoSurrogate:
        "البحث عن طريق Sire Id  اسم الجنين  سلالة السد البديلة ",
      selectDate: "حدد تاريخ'",
      orgnisationNameContainNumber: "يجب ألا يحتوي اسم Orgnisation على رقم ",
      selectBirthEase: "حدد بسهولة الولادة ",
      selectUnit: "الرجاء تحديد وحدة ",
      animalConceptionAddedSuccessfully: "تمت إضافة تصور الحيوانات بنجاح ",
      postageCustomerName: "اسم عميل البريد ",
      searchByPostageCustNameCustAddPostId:
        "ابحث عن طريق البريد اسم العميل  عنوان العميل  معرف النشر ",
      dateOfSemenCollection: "تاريخ مجموعة السائل المنوي ",
      dateOfSemenPreparation: "تاريخ تحضير السائل المنوي ",
      semenMotility: "حركية السائل المنوي ",
      semenConcentration: "تركيز السائل المنوي ",
      postageEdit: "تحرير البريد ",
      enterSireId: "أدخل معرف Sire ",
      selectEmbryoOrganisation: "حدد منظمة الجنين ",
      matingDateH: "تاريخ الحمل  إما التزاوج الطبيعي أو التلقيح الاصطناعي ",
      inseminatorNameH:
        "الشخص الذي يقوم بعملية التلقيح (الطبيب البيطري/الفني) ",
      orgNameH:
        "اسم المنظمة أو الشركة التي توفر القش المنوي لمنظمة العفو الدولية ",
      brServiceNumH:
        "تسجيل عدد التكاثر (على سبيل المثال الأول أو الثاني أو الثالث) ",
      conceptionMethodH:
        "الطريقة التي تصورها الحيوان التي كانت بداية الحمل  تتميز بتخصيب البيضة بواسطة الحيوانات المنوية. ",
      sireIdH:
        "هوية أو رقم تسجيل للوالد الذكر لحيوان  وخاصة الثور المحفوظة للتربية أو السائل المنوي الثيران المستخدمة في التلقيح الاصطناعي.    ",
      damIdH:
        "معرف أو تسجيل عدد سد الحيوان-والدين للحيوان. في حالة نقل الجنين  فإن معرف السد هو الذي تبرع بجنين لنقل الجنين. ",
      sarogatedDamH:
        "إذا كان الحيوان المولود من خلال نقل الجنين. هذا هو معرف الأم الحامل/حيوان أنثى يتم تشريبه (كما هو الحال عن طريق نقل الجنين أو التلقيح الاصطناعي) من أجل تحمل الشباب بدلاً من حيوان آخر.         ",
      embOrgNameH: "اسم المنظمة للجنين ",
      sarogateDamBreedH: "تاريخ سلالة بديل ",
      sireBreedH: "نوع السلالة المليئة (براهمان  بوران) ",
      pregCheckDateH:
        "يمكن اكتشاف الحمل في الأبقار في وقت مبكر من 30 يومًا باستخدام اختبارات الموجات فوق الصوتية والدم. للأبقار التي يتم تحديدها على أنها حامل باستخدام طريقة الجس  غالبًا ما تكون الأبقار حاملًا ما لا يقل عن 35 إلى 50 يومًا. تستخدم الموجات فوق الصوتية لتشخيص الحمل في 40 - 75 يومًا من الحمل. ",
      conceptionSuccessH:
        " في الماشية  يبلغ معدل الإخصاب 90 ٪ مع متوسط ​​معدل الولادة يبلغ حوالي 55 ٪  مما يشير إلى وجود وفيات الجنينية المعدن حوالي 35 ٪ (Diskin et al.  2006). علاوة على ذلك  يحدث 70 إلى 80 ٪ من إجمالي فقدان الجنين خلال الأسابيع الثلاثة الأولى بعد التلقيح  خاصة بين الأيام 7 و 16.   ",
      pregnancyCheckOperatorH:
        "الأطباء البيطريين وفنيي الحيوانات المتخصصين يوفرون هذه الخدمات للمزارعين. كلا الإجراءين غازيين ويتطلب الممارسون تدريبات مكثفة من أجل إجراء الإجراء بأمان (للبقرة والمشغل) بدقة كافية وسرعة للخدمة لتكون قابلة للحياة اقتصاديًا.",
      pregnancyCheckMethodH:
        "الأساليب الأكثر استخدامًا لتشخيص الحمل للماشية هما الجس اليدوي للجهاز التناسلي (لكل مستقيم) والتصوير بالموجات فوق الصوتية عبر التكاثر ",
      deliveryDateH: "التاريخ الذي يحدث فيه تسليم الولادة ",
      calfIdH: "معرف العجل المولود الجديد ",
      birthEaseH:
        "الولادة في الماشية هي عملية طبيعية ولكن في بعض الأحيان يمكن أن تكون هناك مشاكل في الولادة حيث يحتاج السد إلى مساعدة من المزارع/الرعوية.",
      birthDayOldWeightH: "وزن حيوان في يوم الولادة أو وزن طائر عمره يوم واحد ",
    },
    all: "الجميع'",
    ungrouped: "حيوانات غير مجمعة ",
    active: "الحيوانات المجمعة ",
  },
  dashboardS: {
    dailyActivities: "الأنشطة اليومية ",
    pendingTasks: "المهام العالقة'",
    performanceOfGeno: "أداء الأنماط الجينية ",
    breed: "تكاثر'",
    chromosome: "كروموسوم'",
    seqChange: "تغيير التسلسل '",
    inheritance: "ميراث'",
    diseaseName: "اسم المرض ",
    refSequence: "التسلسل المرجعي ",
    pubmedRef: "PubMed Reference '",
    matingDate: "تاريخ التزاوج ",
    inseminatorName: "اسم اللوح ",
    orgName: "اسم المنظمة ",
    brServiceNum: "رقم خدمة التكاثر ",
    conceptionMethod: "طريقة التصور ",
    semEmbInfo: "معلومات السائل المنوي/الجنين ",
    sireId: "معرف المواليد ",
    damID: "معرف السد ",
    srgDamId: "معرف السد البديل ",
    embOrgName: "الجنين org. اسم'",
    srgDamBreed: "سلالة السد البديلة ",
    sireBreed: "سلالة المواليد ",
    damBreed: "سلالة السد",
  },
  user: {
    selectLanguage:"اختار اللغة",
    unitPreference:"تفضيل الوحدة",
    selectUnitOfMeasure:"حدد وحدة القياس",
    importedUser: "مستخدم مستورد",
    impFileStatus: "حالة ملف الاستيراد",
    loadingUser: "تحميل المستخدمين ... يرجى الانتظار",
    totalUsers: "إجمالي المستخدمين",
    pendingUsers: "المستخدمون المعلقون",
    changePassword: "تغيير كلمة المرور",
    goodIdeaToUsePassword:
      "من الجيد استخدام كلمة مرور قوية لا تستخدمها في أي مكان آخر.",
    enterCurrentPassword: "إدخل كلمة السر الحالية",
    enterNewPassword: "أدخل كلمة مرور جديدة",
    reEnterPassword: "أعد إدخال كلمة المرور الجديدة",
    enterPassword: "أدخل كلمة المرور",
    repeatNewPassword: "كرر كلمة المرور الجديدة",
    emailAddr: "عنوان البريد الإلكتروني",
    enterYourPhoneNumber: "أدخل رقم هاتفك",
    pleaseTypeOldPassword: "الرجاء كتابة كلمة المرور القديمة.",
    pleaseTypeNewPassword: "الرجاء كتابة كلمة مرور جديدة.",
    pleaseTypeConfirmPassword: "الرجاء كتابة تأكيد كلمة المرور.",
    passwordChangedSuccesFully: "تم تغيير الرقم السري بنجاح",
    currentPassword: "كلمة السر الحالية",
    newPassword: "كلمة المرور الجديدة",
    passwordDoesNotMatch: "كلمات المرور غير متطابقة.",
    emailCanNotBeEmpty: "لا يمكن أن يكون البريد الإلكتروني فارغًا",
    profileUpdated: "تحديث الملف الشخصي",
    profileNotUpdated: "الملف الشخصي غير محدث",
    unableToVerifyEmail: "تعذر التحقق من البريد الإلكتروني",
    otpSentOnEmail: "تم إرسال OTP عبر البريد الإلكتروني",
    otpSentSuccessFully: "تم إرسال OTP بنجاح",
    importUsers: "استيراد المستخدمين",
    imageUpdated: "تم تحديث الصورة",
    departmentName: "اسم القسم",
    departmentNum: "رقم القسم",
    departmentAdded: "تمت إضافة القسم",
    departmentNotAdded: "قسم غير مضاف",
    searchDepartnment: "البحث عن طريق اسم القسم أو الرقم",
    addDepartMent: "اضافة قسم",
    addDepartment: "اضافة قسم",
    roleNameIsRequired: "اسم الدور مطلوب",
    roleNameMustBeLessThan15Chars: "يجب أن يكون اسم الدور أقل من 15 حرفًا",
    roleAdded: "تمت إضافة الدور",
    editDepartment: "تحرير القسم",
    departmentUpdated: "قسم محدث",
    departmentNotUpdated: "قسم غير محدث",
    deleteDepartment: "حذف القسم",
    deleteDepartmentMessage: "هل أنت متأكد أنك تريد حذف هذا القسم.",
    noRoleAvailable: "لا يوجد دور متاح",
    roleUpdated: "تم تحديث الدور",
    roleNotUpdated: "الدور غير محدث",
    editRole: "تحرير الدور",
    allRole: "كل دور",
    addNewRole: "إضافة دور جديد",
    allDepartment: "كل الاقسام",
    permissionsUpdated: "تم تحديث الأذونات",
    permissionsnotUpdated: "لم يتم تحديث الأذونات",
    roleNo: "الدور رقم",
    searchByEmailAndName: "البحث عن طريق البريد الإلكتروني والاسم",
    userID: "معرف المستخدم",
    userUpdated: "تم تحديث المستخدم",
    userNotUpdated: "المستخدم غير محدث",
    userAdded: "تمت إضافة المستخدم",
    userNotAdded: "المستخدم غير مضاف",
    activateUser: "تنشيط المستخدم",
    deactivateUser: "قم بإلغاء تنشيط المستخدم",
    userStatusMsg: "هل أنت متأكد أنك تريد تغيير حالة المستخدم",
    countryRequired: "الدولة مطلوبة",
    stateRequired: "الدولة مطلوبة",
    cityRequired: "المدينة مطلوبة",
    searchByRole: "البحث عن طريق رقم الدور ، اسم الدور ، القسم",
    noModuleAvailable: "لا توجد وحدة نمطية متاحة",
    searchBYModuleName: "البحث عن طريق اسم الوحدة",
  },

  farm: {
    farmID: "معرف المزرعة",
    onTheFarm: "في المزرعة",
    userRoles: "أدوار المستخدمين",
    adduser: "إضافة مستخدم",
    addAuser: "أضف مستخدم",
    uploadUsers: "تحميل المستخدمين",
    addNewUser: "إضافة مستخدم جديد",
    selectDept: "حدد القسم",
    selectRole: "حدد الدور",
    editUser: "تحرير العضو",
    totalFarms: "إجمالي المزارع",
    NoAnimalsRegisteredForthisFarm: "لم يتم تسجيل أي حيوانات في هذه المزرعة",
    farmsPerPage: "مزارع في الصفحة",
    regularFarms: "مزارع عادية",
    farmRegisteredProducts: "منتجات المزرعة المسجلة",
    searchByFarmNameAndId: "البحث عن طريق اسم المزرعة والمعرف",
    loadingProductsPleaseWait: "جاري تحميل المنتجات ... من فضلك انتظر",
    farmName: "اسم المزرعة",
    farmLocation: "موقع المزرعة",
    productName: "اسم المنتج",
    stockStatus: "حالة الرصيد، وضع مخزون",
    inStock: "في الأوراق المالية",
    searchByProductName: "البحث عن طريق اسم المنتج",
    productCategory: "فئة المنتج",
    products: "منتجات",
    farms: "مزارع",
    registerAfarm: "سجل مزرعة",
    govtRegistry: "مشاريع سياحية. ",
    cooperativeID: "الرقم التعاوني",
    farmType: "نوع المزرعة",
    contractMating: "عقد التزاوج",
    customization: "التخصيص",
    recordsPerpage: "تسجيلات لكل صفحة",
    restoreDefault: "استعادة الافتراضي",
    apply: "يتقدم",
    searchState:
      "البحث عن طريق معرف المزرعة ، السجل الحكومي ، المعرف التعاوني ، نوع المزرعة ، عقد التزاوج",
    farmOwner: "صاحب المزرعة",
    govRegistrationNo: "رقم التسجيل الحكومي",
    farmInformation: "معلومات المزرعة",
    ownershipType: "نوع الملكية",
    communityName: "اسم المجتمع",
    farmLicenseInformation: "معلومات رخصة المزرعة",
    licenseNumber: "رقم الرخصة",
    licenseExpiryDate: "تاريخ انتهاء الترخيص",
    regulatorName: "اسم المنظم",
    regulatorRepresentativeName: "اسم ممثل المنظم",
    farmLocationSize: "موقع المزرعة",
    productionSystem: "نظام الإنتاج",
    country: "دولة",
    state: "ولاية",
    city: "مدينة",
    street: "شارع",
    houseNumber: "رقم الدار",
    farmRegistration: "تسجيل المزرعة",
    cancel: "يلغي",
    register: "يسجل",
    ok: "نعم",
    totalFarmSize: "إجمالي حجم المزرعة",
    farmGeographicLocation: "موقع المزرعة الجغرافي",
    perimeterPointLongitude: "خط طول نقطة المحيط",
    perimeterPointLatitude: "خط عرض نقطة المحيط",
    perimeterPointLabel: "تسمية نقطة المحيط",
    perimeterLength: "طول المحيط",
    farmLatitude: "خط عرض المزرعة",
    farmLongitude: "خط طول المزرعة",
    editFarm: "تحرير المزرعة",
    update: "تحديث",
    editAfarm: "تحرير مزرعة",
    nextFarm: "المزرعة التالية",
    nameoftheFarm: "اسم المزرعة",
    registerAProduct: " تسجيل منتج",
    farmProducts: "منتجات مزارع",
    calf: "عجل",
    steer: "توجيه",
    heifer: "هايفر",
    sire: "مولى",
    dam: "سد",
    registerAnAnimal: "سجل حيوان",
    farmAnimals: "حيوانات المزرعة",
    farm_type: "نوع المزرعة",
    farm_Owner: "صاحب المزرعة",
    dateOfRegistration: "تاريخ التسجيل",
    dataIsNotAvailableForThisFarm: "البيانات غير متوفرة لهذه المزرعة",
    registerNewProduct: "تسجيل منتج جديد",
    information: "معلومة",
    licenseInfo: "معلومات الترخيص",
    locationInfo: "معلومات الموقع",
    geoLocation: "الموقع الجغرافي",
    perimeterLengthState: "طول محيط المزارع (طول السياج)",
    totalFarmSizeState: "حجم المزرعة",
    productionSystemState: "نظام الإنتاج المستخدم في المزرعة",
    contractMatingState: "برنامج التزاوج في العقد الذي تشارك فيه المزرعة.",
    ownershipTypeState: "نوع الملكية",
    regulatorRepresentativeNameState:
      "اسم الشخص الذي يمثل المنظم الذي أصدر الترخيص",
    regulatorNameState: "اسم الجهة المنظمة التي أصدرت الترخيص",
    licenseExpiryDateState: "التاريخ الذي تنتهي فيه صلاحية الترخيص الحالي",
    licenseNumberState: "تم إصدار رقم الترخيص من قبل المنظم",
    plotNumberState: "رقم بيت المزرعة.",
    plotNumber: "رقم المنزل / قطعة الأرض",
    streetStatement: "اسم شارع المزرعة.",
    cityStatement: "المدينة التي تقع فيها المزرعة.",
    stateStatement: "منطقة الدولة التي تقع فيها المزرعة.",
    countryState: "البلد الذي تقع فيه المزرعة.",
    perimeterPointLongitudeState: "خط الطول لنقطة واحدة في المزرعة.",
    perimeterPointLatitudeState: "خط عرض نقطة واحدة في المزرعة.",
    perimeterPointLabelState: "تسمية النقطة.",
    farmLongitudeState: "خط الطول للمزرعة.",
    farmLatitudeState: "خط عرض المزرعة.",
    farmNameH: "اسم المزرعة",
    farmTypeH: "نوع المزرعة التي يتم فيها تنفيذ الأنشطة المختلفة.",
    farmOwnerH: "اسم مالك المزرعة (إنشاء تلقائي لإدخال اسم المزارع)",
    ownershipTypeH:
      "نوع المزارعين الذين يمتلكون / يتحكمون في الأرض التي يزرعونها وأولئك الذين لا يملكون.",
    govtRegNumbH: "رقم سجل المزرعة الذي تم تعيينه من قبل المنظم",
    contractMatingH: "كود برنامج التزاوج التعاقدي الذي تشارك فيه المزرعة",
    productionSystemH: "ما هو نظام الإنتاج المستخدم في المزرعة",
    cooperativeIDH: "معرّف التعاونية التي تنتمي المزرعة إليها ",
    licenseNumberH: "تحديد رقم على ترخيص صادر عن منظم يحدده مع المالك.",
    licenseExpiryDateH: "التاريخ الذي تنتهي فيه صلاحية الترخيص الحالي",
    regularNameH: "اسم الجهة المنظمة التي أصدرت الترخيص",
    regularRepName: "اسم الشخص الذي يمثل المنظم الذي أصدر الترخيص",
    countryH: "البلد الذي تقع فيه المزرعة.",
    stateH: "منطقة الدولة التي تقع فيها المزرعة.",
    cityH: "المدينة التي تقع فيها المزرعة.",
    streetH: "اسم شارع المزرعة.",
    houseNumberH: "رقم بيت المزرعة.",
    totalFarmSizeH:
      "حجم المزرعة هو مجموع الأراضي التي تزرعها المزرعة حاليًا بما في ذلك الأراضي المحروسة ولكن باستثناء الأراضي المزروعة بالنباتات الطبيعية أو الأشجار أو المراعي.",
    farmLatitudeH: "هو قياس المسافة شمال أو جنوب خط الاستواء. ",
    farmLongitudeH: "يقيس المسافة شرق أو غرب خط الزوال الرئيسي.",
    perimeterLengthH: "طول محيط المزارع (طول السياج)",
    perimeterPointLabelH: "تسمية النقطة. ",
    perimeterPointLatH: "خط عرض نقطة واحدة في المزرعة",
    perimeterPointLongH: "خط الطول لنقطة واحدة في المزرعة",
    noProductAvailable: "لا يوجد منتج متوفر",
    farmUpdated: "تم تحديث المزرعة",
    performance: "أداء",
    milkInformation: "معلومات الحليب",
    farmNameRequired: "اسم المزرعة مطلوب",
  },

  login: {
    welcome: "مرحباً! تسجيل الدخول'",
    welInfo: "أدخل بيانات الاعتماد الخاصة بك. '",
    login: "تسجيل الدخول'",
    forgotPassword:"هل نسيت كلمة السر",
    forgotPasswordDesc:"الرجاء إدخال عنوان البريد الإلكتروني المرتبط بحسابك. سيتم إرسال تفاصيل كلمة المرور إلى عنوان بريدك الإلكتروني.",
    backToLogin:"العودة إلى تسجيل الدخول",
  },
  actionListmod: {
    actionList: "قائمة الإجراءات ",
    tODAY: "اليوم",
    createTask: "إنشاء مهمة ",
    myActivities: "نشاطاتي",
    jhonSmith: "جيون سميث ",
    farmID: "معرف المزرعة ",
    dateOfEvent: "تاريخ الحدث",
    actionRequired: "الإجراء مطلوب",
    actionTaken: "تم اتخاذ فعل",
    animalEventID: "معرف الحدث الحيواني ",
    cANCEL: "يلغي",
    cONFIRM: "يتأكد",
    sTATEMENT: "هل أنت متأكد أنك تريد حذف هذا السجل؟",
    dAY: "يوم",
    wEEK: "أسبوع",
    mONTH: "شهر",
    sUBMIT: "يُقدِّم",
    startDate: "تاريخ البدء",
    endDate: "تاريخ الانتهاء",
    rEPEAT: "يكرر",
    taskCategory: "فئة المهام ",
    pRIORITY: "أولوية",
    aSSIGNEE: "المحاليل ",
    selectLocation: "اختر موقعا",
    selectAnimals: "حدد حيوانًا واحدًا أو أكثر ",
    dESCRIPTION: "وصف",
    customRecurrence: "تكرار مخصص ",
    repeatEvery: "تكرار كل",
    taskName: "اسم المهمة",
    enterDescription: "أدخل الوصف",
    toDo: "لكى يفعل",
    assignTo: "يسند إلى",
    status: "حالة",
    nOTE: "ملحوظة",
    noTaskAvailable: "لا توجد مهمة متاحة ",
    healthRecord: "السجل الصحي",
    iD: "بطاقة تعريف",
    tAG: "بطاقة شعار",
    dateOfbirth: "تاريخ الميلاد",
    taskTakenat: "المهمة التي اتخذت في ",
    gENDER: "جنس",
    bREED: "تكاثر",
    regDate: "ريج. تاريخ",
    updateHealthRecord: "تحديث السجل الصحي للحيوانات ",
    treatment: "علاج",
    reasonOftreatment: "سبب العلاج ",
    treatmentDate: "تاريخ العلاج ",
    dIAGNOSIS: "تشخبص",
    drugId: "معرف المخدرات ",
    drugName: "اسم المخدرات ",
    drugWithdrawalperiod: "فترة انسحاب المخدرات ",
    attendingVeterinarian: "حضور الطبيب البيطري ",
    packId: "معرف الحزمة ",
    noItemsselected: "لا توجد عناصر محددة ",
    healthRecordsubmission: "تقديم السجل الصحي ",
    inseminationRecordsubmission: "تقديم السجل التقييمي ",
    inseminatorName: "اسم اللوح ",
    inseminatorId: "معرف اللذيذ ",
    conceptionRate: "معدل التصور ",
    dateOfmeasurement: "تاريخ القياس ",
    recordSubmission: "التقديم السجل ",
    uPDATE: "تحديث",
    updateTask: "تحديث المهمة",
  },
  inseminatorStatisticsInfo: {
    addInseminatorInfo: "أضف معلومات اللوحات ",
    inseminatorNumber: "رقم اللوح ",
    loadingInseminatorPleaseWait: "تحميل inseminator ... يرجى الانتظار '",
    searchByIDAndName: "ابحث بالمعرف والاسم ",
    inseminatorInfoAdded: "تمت إضافة معلومات inneminator '",
    inseminatorInfoNotAdded: "معلومات اللبطاء لم تتم إضافتها ",
    inseminatorInfoUpdated: "تم تحديث معلومات Inneminator ",
    inseminatorInfoNotUpdated: "معلومات غير محدثة ",
    editAInseminatorInfo: "تحرير معلومات inminator '",
    inseminatorList: "قائمة اللوحات ",
    inseminatorInfoDetails: "تفاصيل معلومات Inseminator '",
    updateInseminatorInfo: "تحديث معلومات اللوحات '",
  },
  organizationNtrInfo: {
    loadingOrdersPleaseWait: "أوامر التحميل ... يرجى الانتظار ",
    addStocks: "أضف الأسهم ",
    addStock: "أضف الأسهم ",
    quantity: "كمية'",
    selectUnit: "حدد الوحدة ",
    farmProducts: "منتجات مزارع'",
    cost: "يكلف'",
    transactionID: "رقم المعاملة'",
    recipientID: "معرف المتلقي ",
    orderID: "رقم التعريف الخاص بالطلب'",
    recepientName: "اسم الربح ",
    createAOrder: "إنشاء طلب '",
    totalStocks: "إجمالي الأسهم ",
    orders: "طلبات'",
    totalPending: "إجمالي معلق ",
    totalDelivered: "إجمالي تسليمه ",
    searchByRecepientNameOrderIdRecepientId:
      "ابحث عن طريق الاسم الرصيف  معرف الطلب  معرف الرصيف ",
    chooseTheDate: "اختر التاريخ ",
    transactionDate: "تاريخ الصفقة'",
    selectCategory: "اختر الفئة'",
    volumeOfProduct: "حجم المنتج ",
    productQuantity: "كمية المنتج'",
    productRecipientId: "معرف مستلم المنتج ",
    productRecipientName: "اسم مستلم المنتج ",
    productRecipientType: "نوع مستلم المنتج '",
    singleProduct: "منتج واحد'",
    orderPlaced: "تم الطلب'",
    orderNotPlaced: "أمر لم يتم وضعه ",
    totalPrice: "السعر الكلي'",
    currency: "عملة'",
    selectCurrency: "اختر العملة'",
    address: "عنوان'",
    enterAddress: "أدخل العنوان'",
    attachments: "المرفقات ",
    chooseFile: "اختر ملف'",
    nameOfTheFarm: "اسم المزرعة ",
    loremIpsumHasBeenTheIndustrySStandardDummyText:
      "لقد كان Lorem Ipsum نصًا وهميًا قياسيًا في الصناعة منذ القرن السادس عشر  عندما استولت طابعة غير معروفة ",
    billedTo: "فاتورة إلى '",
    orderStatus: "حالة الطلب'",
    selectStatus: "حدد الحالة ",
    cadbury: "كادبوري ",
    totalAmount: "المبلغ الإجمالي'",
    deliveryCharges: "رسوم التسليم ",
    orderDetails: "تفاصيل الطلب",
    deliveryOnTime: "توصيلة على الوقت'",
    productID: "معرف المنتج'",
    productRegistration: "تسجيل المنتج'",
    enterTheNameOfTheProduct: "أدخل اسم المنتج ",
    nameOfTheProduct: "اسم المنتج'",
    productAdded: "تمت إضافة المنتج ",
    productNotAdded: "المنتج لم يضاف '",
  },
  drug: {
    dRUGS: "المخدرات",
    registerAdrug: "تسجيل دواء ",
    sEARCH: "يبحث",
    genericName: "اسم عام",
    manufacturer: "الصانع",
    distributor: "موزع",
    registrationDate: "تاريخ التسجيل",
    drugRegistration: "تسجيل المخدرات ",
    drugInformation: "معلومات المخدرات ",
    packExpiration: "حزمة انتهاء الصلاحية ",
    drugId: "معرف المخدرات ",
    drugName: "اسم المخدرات ",
    drugGenericname: "الاسم العام للمخدرات ",
    drugManufacturer: "الشركة المصنعة للأدوية ",
    distributorName: "اسم الموزع",
    drugRegistrationdate: "تاريخ تسجيل المخدرات ",
    nextDrug: "الدواء التالي ",
    editDrug: "تحرير المخدرات ",
    updateDrug: "تحديث الدواء ",
    deleteDrug: "حذف المخدرات ",
    noRecordfound: "لا يوجد سجلات",
    addDrug: "أضف المخدرات ",
    statementDrug: "تم حذف الدواء. انقر فوق الزر أدناه للتسجيل. ب",
    cANCEL: "يلغي",
    cONFIRM: "يتأكد",
    sTATEMENT: "هل أنت متأكد أنك تريد حذف هذا السجل؟",
    ok: " نعم",
    information: "معلومة",
    packOrder: "ترتيب الحزمة ",
    packPrescription: "وصفة طبية ",
    packReservation: "حجز الحزمة ",
    packLocation: "موقع الحزمة ",
    drugDozedam: "جرعة المخدرات في يوم واحد للسد ",
    drugDozecalf: "جرعة المخدرات في يوم للعجل ",
    drugFormate: "شكل المخدرات ",
    drugDistributor: "موزع المخدرات ",
    drugActiveingridents: "المكونات النشطة للمخدرات ",
    drugSubstitutionId: "معرف استبدال المخدرات ",
    packId: "معرف الحزمة ",
    packBatchNumber: "رقم الدُفعة ",
    drugIdStatement: "عدد الدُفعة من الدواء ",
    drugNameSatement:
      "اسم العلامة التجارية المعلن الذي يتم بموجبه بيع الدواء. ",
    drugGenericnameStatement:
      "المكياج الكيميائي للعقار بدلاً من الاسم العلامة التجارية المعلن الذي يتم بموجبه بيع الدواء. ",
    drugFormateSatement: "عدد الدُفعة من الدواء ",
    drugDozecalfSatement: "لمعرفة كمية جرعة المخدرات إلى العجل. ",
    drugDozedamStatement: "لمعرفة كمية جرعة المخدرات إلى السد ",
    drugManufacturerStatement: "تفاصيل الشركة المصنعة للأدوية ",
    drugDistributorStatement: "تفاصيل موزع المخدرات ",
    drugRegistrationdateStatement: "تاريخ تسجيل المخدرات في البلد المحدد. ",
    drugActiveingridentsStatement: "قائمة المكونات النشطة. ",
    drugSubstitutionIdStatement:
      "معرفات بدائل محتملة للدواء في الحالة  فإن الدواء الرئيسي غير متوفر حاليًا.",
    packIdStatement: "الرمز الشريطي أو معرف RF للحزمة. ",
    packBatchNumberStatement:
      "رقم الدُفعة المعين للحزمة من قبل الشركة المصنعة. ",
    locationWarehouseID: "معرف مستودع الموقع ",
    locationWarehouseIDState: "معرف المستودع حيث يتم تخزين الحزمة. ",
    locationRackID: "معرف رف الموقع ",
    locationRackIDStatement: "معرف الرف حيث يتم تخزين العبوة. ",
    locationTierID: "معرف موقع الموقع ",
    locationTierIDStatement: "معرف الطبقة على الرف حيث يتم تخزين العبوة. ",
    locationPositionID: "معرف موقع الموقع ",
    locationPositionIDStatement: "معرف الموضع على طبقة حيث يتم تخزين العبوة. ",
    storageTemperatureCondition: "حالة درجة حرارة التخزين ",
    storageTemperatureConditionStats: "حالة تخزين الحزمة. ",
    containerForm: "شكل الحاوية ",
    containerFormStatement: "شكل من الحاويات التي كان معبأ الدواء فيها ",
    consistQuantity: "تتكون من كمية ",
    consistQuantityStatement: "كمية الحبوب والزجاجات وما إلى ذلك في الحزمة. ",
    releaseId: "معرف الإصدار ",
    releaseIdStatement: "معرف الذي تم تعيينه بعد الحزمة يؤخذ من قبل المزارع. ",
    releaseDate: "تاريخ الافراج عنه",
    releaseDateStatement:
      "التاريخ الذي تم فيه أخذ العبوة من المخزون من قبل المزارع. ",
    packManufacturedDate: "تاريخ تصنيع حزمة ",
    packManufacturedDateStatement: "تاريخ عندما تم تصنيع العبوة. ",
    packImportedDate: "تاريخ الحزمة المستوردة ",
    packImportedDateStatement: "التاريخ الذي تم فيه استيراد العبوة. ",
    packExpirationDate: "تاريخ انتهاء الصلاحية ",
    packExpirationDateStatement: "التاريخ عند انتهاء صلاحية العبوة ",
    expiredSoonFlag: "انتهت صلاحية العلم قريبا ",
    expiredSoonFlagState: "تحذير من انتهاء صلاحية الحزمة قريبًا ",
    packTotalVolumeLeft: "حزمة إجمالي الحجم اليسار ",
    packTotalVolumeLeftState:
      "إجمالي عدد الحزم مع نفس المكونات المتبقية في المخزون. ",
    packOrderID: "معرف الطلب ",
    packOrderIDState: "المعرف الذي تم تعيينه بعد طلب الحزمة من الموزع. ",
    packQuantityOrdered: "تم طلب كمية حزمة ",
    packQuantityOrderedState: "عدد الحزم التي تم طلبها من الموزع. ",
    packPrice: "سعر الحزمة ",
    packPriceStatement: "سعر العبوة. ",
    priceCurrency: "عملة السعر ",
    packPricecurrency: "عملة سعر الحزمة ",
    packPricecurrencyState: "اسم العملة الذي يتم فيه ترشيح السعر. ",
    packPaydate: "تاريخ دفع الحزمة ",
    payDate: "تاريخ الدفع",
    packPaydateState: "التاريخ الذي تم فيه إصدار الدفع إلى الموزع. ",
    packShippingID: "معرف الشحن ",
    shippingID: "معرف الشحن ",
    packShippingIdState: "معرف الشحن للحزمة عند وصوله من الموزع. ",
    packShippingDate: "تاريخ الشحن ",
    shippingDate: "تاريخ الشحن",
    packShippingDateState: "تاريخ وصول الحزمة في الأسهم ",
    packOrderStatus: "حالة الطلب ",
    packOrderStatusState: "حالة الترتيب الحالي. ",
    recepientKeeperId: "معرف حارس مرمى ",
    recepientKeeperIdStatement: "اسم الفرد/المنظمة الذين تلقوا الحزمة ",
    recepientFarmId: "معرف مزرعة ربح ",
    recepientFarmIdStatement:
      "معرف المزرعة حيث ينتمي عملية إعادة تصميم المخدرات المتحركة إلى. ",
    recepientAnimalId: "معرف الحيوان الرصيف ",
    recepientAnimalIdState: "معرف الحيوان الذي وصفه الدواء (حزمة).",
    specialistComments: "تعليقات متخصصة ",
    specialistCommentsState: "تعليقات متخصصة/بيطرية حول الوصفة الطبية. ",
    specialistName: "اسم متخصص ",
    specialistNameState: "اسم المتخصص/البيطري الذي وصف الدواء ",
    specialistID: "معرف متخصص ",
    specialistIDState: "معرف المتخصص/البيطري الذي وصف الدواء ",
    reservedByKeeperId: "محجوز بواسطة معرف Keeper ",
    reservedByKeeperIdState: "معرف Keeper من الذي حجز الحزمة. ",
    reservedByFarmId: "محجوز بواسطة معرف المزرعة ",
    reservedByFarmIdState: "معرف المزرعة الذي تم حجز الحزمة ل. ",
    reservationTimeoutDate: "تاريخ مهلة الحجز ",
    reservationTimeoutDateState:
      "التاريخ الذي سيتم فيه إلغاء الحجز تلقائيًا إذا لم يتم شراؤ الحزمة. ",
    reservationTimeout: "مهلة الحجز ",
    reservationTimeoutState:
      "بعد ذلك  سيتم إلغاء عدد ساعات الحجز تلقائيًا إذا لم يتم شراؤ الحزمة أو أخذها ",
    reservationDate: "تاريخ الحجز ",
    reservationDateState: "تاريخ حجز الحزمة ",
    reservationStatus: "حالة الحجز ",
    reservationStatusState:
      "حالة حجز الحزمة. العبوة غير متوفرة للآخرين إذا تم حجزها. ",
    loadingDrugsPleaseWait: "تحميل المخدرات ... من فضلك انتظر ",
    quantityOrder: "ترتيب الكمية ",
    keeperID: "معرف Keeper ",
    timeoutDate: "تاريخ المهلة ",
    warehouseID: "معرف المستودع ",
    rackID: "معرف الرف ",
    tierID: "معرف الطبقة ",
    positionID: "معرف الموقف ",
    temperatureCondition: "حالة درجة الحرارة ",
    manufactureDate: "تاريخ الصنع",
    importedDate: "التاريخ المستورد ",
    totalVolumeLeft: "إجمالي الحجم اليسار",
  },
  reports: {
    myReports: "تقاريري ",
    satelliteReports: "تقارير الأقمار الصناعية ",
    weatherReports: "تقارير الطقس",
    pregnancyAnalytics: "تحليلات الحمل ",
    semenEmbroyAnalytics: "تحليلات السائل المنوي/ormroy ",
    semenAnalytics: "تحليلات السائل المنوي ",
    embryoAnalytics: "تحليلات الجنين ",
    calfAnalytics: "تحليلات العجل ",
    milkProduction: "إنتاج الحليب ",
    totalMilkType: "إجمالي نوع الحليب ",
    totalAnimalAnalytics: "إجمالي تحليلات الحيوانات ",
    animalAnalytics: "تحليلات الحيوانات ",
    analyticsAndReporting: "التحليلات والإبلاغ ",
    filterByCountry: "تصفية حسب البلد ",
    filterByFarm: "تصفية بواسطة المزرعة ",
    filterByRegion: "مرشح حسب المنطقة ",
    filterByMonth: "تصفية حسب الشهر ",
    filterByDate: "تصفية حسب التاريخ ",
    filterByRole: "تصفية الدور ",
    filterByYear: "تصفية حسب السنة ",
    filterByTrait: "تصفية بسمات ",
    avgBreedingValue: "متوسط ​​قيمة التكاثر ",
    avgEconomicIndex: "متوسط ​​المؤشر الاقتصادي ",
    breederReport: "تقرير مربي ",
    semenTransferDate: "تاريخ نقل السائل المنوي ",
    semenEmbryoProductionReport: "تقرير إنتاج السائل المنوي/الجنين ",
    semenProducts: "منتجات السائل المنوي ",
    meatProducts: "منتجات اللحوم",
    totalProducts: "إجمالي المنتجات ",
    semenEmbryoReport: "تقرير السائل المنوي/الجنين ",
    numOfStraws: "عدد القش ",
    collectionDate: "تاريخ التحصيل ",
    productionReport: "تقرير الإنتاج ",
    receipientId: "معرف الاستلام ",
    embryoId: "معرف الجنين ",
    semenStrawId: "معرف سائل المنوي ",
    dataScientist: "عالم البيانات",
    dataScientistReport: "تقرير عالم البيانات ",
    productReport: "تقرير المنتج ",
    dairyProducts: "منتجات الألبان",
  },
  genoPerformance: {
    performanceOfGenoType: "أداء النمط الوراثي ",
    addAGenoType: "أضف النمط الوراثي ",
    breedName: "اسم تولد ",
    chromosome: "كروموسوم",
    sequenceChange: "تغيير التسلسل ",
    inheritance: "ميراث",
    diseaseName: "اسم المرض ",
    referenceSequence: "التسلسل المرجعي ",
    pubmedReference: "مرجع PubMed ",
    genoTypeRegistration: "تسجيل النمط الوراثي ",
    breed: "تكاثر",
    editAGenoType: "تحرير النمط الوراثي ",
    editGenoType: "تحرير النمط الوراثي ",
    loadingGene: "تحميل جينو ... من فضلك انتظر ",
    geneTypeList: "قائمة النمط الوراثي ",
  },
  reportings: {
    conception: "تصور (عالم البيانات) ",
    performanceOfGenoData: "أداء النمط الوراثي (عالم البيانات) ",
    totalInsemination: "التلقيح الكلي ",
    embryo: "الجنين ",
    animalVaccinationRecord: "سجل تطعيم الحيوانات ",
    dataNotAvailable: "البيانات غير متوفرة لهذه المزرعة. ",
    pregnancyStatus: "حالة الحمل ",
    healthReport: "التقرير الخاص بالصحة",
    heavyMilk: "الحليب الثقيل ",
    standardMilk: "الحليب القياسي",
  },
  sidebar: {
    healthAnalytics: "التحليلات الصحية ",
    productionAnalytics: "تحليلات الإنتاج ",
  },
  epd: {
    regNo:
      "Animal Reg No هو الكود الفريد الممنوح للحيوان باستخدام وسيلة للعلامة  وضمان إجراء عملية لتحديد وتتبع حيوانات معينة ",
    internationalID: "معرف الحيوان الدولي ",
    location: "بلد / منطقة ولادة الحيوان ",
    animalName: "الاسم القياسي / تسميات الحيوان ",
    gender: "جنس الحيوان (ذكر/أنثى) ",
    additionalIDMethod:
      "ما هي الطريقة التي تم استخدامها لتحديد الحيوان (على سبيل المثال  TAGE  وشم) ",
    damID:
      "معرف أو عدد التسجيل لسد الحيوان-والد أنثى لحيوان/معرف لعدد من الأم البيولوجية ",
    sireId:
      "هوية أو رقم تسجيل للوالد الذكر لحيوان  وخاصة الثور المحفوظة للتربية أو السائل المنوي الثيران المستخدمة في التلقيح الاصطناعي.    ",
    dateOfBirth: "تاريخ ميلاد الحيوان. ",
    breederHerdCode: "رمز قطيع المربي في الغالب من قبل جمعيات مربي ",
    seasonofBirth: "موسم ميلاد الحيوانات لاحظت في الشهر الحكيم ",
    birthYear: "السنة التي يولد الحيوان ",
    birthManagementCode:
      "رمز إدارة الولادة الذي يقدمه المستخدم/المزارع في الغالب ",
    birthSex: "جنس الحيوان (ذكر/أنثى) ",
    birthWeight: "وزن ميلاد العجل ",
    primaryBreed: "المساهمة الوراثية ٪ ٪ للحيوان ",
    secondaryBreed: "مساهمة وراثية بسيطة للحيوان ",
    breedComposition: "تشير النسبة المئوية لتكوين السلالة إلى التمثيل النسبي للسلالات المختلفة في التركيب الجيني لحيوان فردي أو مجموعة من الحيوانات. ",
    conceptionMethod:
      "كيف تم تصور الحيوان (التزاوج الطبيعي/ التلقيح/ نقل الجنين).",
    accuracyWeight: "وزن الدقة ",
    damAge: "عصر السد في أشهر/سنوات على سبيل المثال عامين  24 شهرا ",
    weaningWeight: "الوزن الفطام لحيوان في وقت الفطام. ",
    weaningDate: "التاريخ الذي فطام فيه الحيوان ",
    weaningSex:
      "جنس الحيوان الذي تم فطامه. مجموع الخصائص التي تميز الكائنات الحية على أساس وظيفتها الإنجابية. ",
    managementPastureCode:
      "الكود المقدم للإدارة/ المراعي من قبل المستخدم/ المزارع ",
    creep:
      "التغذية الزاحفة هي ممارسة توفير تغذية تكميلية (الحبوب أو العلف) لعجول التمريض. ",
    weaningContemporaryGroupCode: "مجموعة من الفطام للوزن المعاصر ",
    birthContemporaryCode: "رمز الولادة المعاصرة ",
    yearlingDate:
      "تاريخ الحيوان البالغ من العمر عام واحد أو في السنة الثانية من عمره ",
    managementFeedUnitCode:
      "الكود المقدم لوحدة الإدارة/ التغذية من قبل المستخدم ",
    yearlingSex: "جنس الحيوان في زمن الزوايا ",
    yearlingWeight:
      "إن وزن السنة هو قياس للنمو المباشر بعد الفطام وغالبًا ما يتم استخدامه لتعكس الأداء المحتمل للذرية المرتبطة بالسوق في ملف التغذية  ويقاس بروليم من العجل. ",
    yearlingHeight: "ارتفاع الحيوان في وقت العدة ",
    yearlingWeightContemporaryGroupCode: "رمز الجماعة المعاصرة لوزن الزوايا ",
    weaningYearlingWeightContemporaryGroupCode:
      "مدونة الفطام أو الجماعة المعاصرة للوزن العام ",
    daysOnFeed:
      "عدد الأيام التي يتم تغذيتها مع هذه الأعلاف الخاصة على سبيل المثال: يتم تغذية أبقار الشباب المتنامية بنظام غذائي عالي الطاقة لإنتاج لحوم البقر القابلة للتسويق بتكلفة منخفضة من المكاسب. اعتمادًا على وزن جسم البدء وعمر الماشية  تتراوح فترة التغذية من 60 يومًا إلى 12 شهرًا ",
    managementFeedUnitPenCode:
      "الكود المقدم إلى وحدة الإدارة/ التغذية/ القلم من قبل المستخدم ",
    harvestDate: "تاريخ ذبح الحيوان (قتل) للحوم ",
    gradingDate: "تم تصنيف تاريخ الجثث وفقًا لمعايير معينة ",
    carcassSex: "جنس الذبيحة ",
    dateonFeed:
      "التاريخ تم نقل الحيوان إلى تغذية جديدة على سبيل المثال: CA الشباب النمو = (يتم تغذية TTLE نظامًا غذائيًا عالي الطاقة لإنتاج لحوم البقر القابلة للتسويق بتكلفة منخفضة من المكسب. اعتمادًا على وزن جسم البدء وعمر الماشية  يتراوح التغذية من 60 يومًا إلى 12 شهرًا ",
    KPH: "٪ KPH هي النسبة المئوية من إجمالي الدهون الموجودة في تجويف الجسم من الذبيحة على وجه التحديد في مناطق الكلى والحوض والقلب. غالبًا ما يتم تقديره بصريًا بواسطة طالب في وزارة الزراعة الأمريكية أو يمكن حسابه بناءً على التغير في وزن الذبيحة بعد إزالة الدهون من هذه المناطق على الذبيحة. معظم الجثث لديها 1 إلى 4 في المئة في الساعة. هذا هو العامل الأخير المستخدم لتحديد درجة العائد. ",
    carcassWeight:
      "وزن الذبيحة هو الوزن الساخن أو غير المودع بعد حصاد وإزالة إخفاء ورأس الجهاز الهضمي والأعضاء الداخلية. يتم الإبلاغ في بعض الأحيان على أنها وزن الذبيحة الساخنة (HCW). يعتبر وزن الذبيحة عاملاً رئيسياً في تحديد قيمة الذبيحة عندما يتم بيع الماشية على أساس الوزن أو على شبكة قائمة على القيمة.",
    fatThickness:
      "يتم قياس سمك الدهون بالبوصة باستخدام مسطرة صغيرة. المكان المناسب لقياس سمك الخلف هو ¾ من الطول لأعلى من Ribeye من نهاية العمود الفقري  عموديًا على السطح الخارجي للثني.",
    marbling:
      "الرخام هو الدهون العضلية غير المشبعة (الصحية) المرئية التي تتراكم داخل العضلات وبين حزم الألياف العضلية. ",
    ribeyeArea:
      "كمية من العين الضلع (loin أو ribeye muscle longissimus dorsi) تقاس بين الأضلاع الثانية عشرة والثالثة 13 في بوصة مربعة باستخدام شبكة (على سبيل المثال  8 أو 9 أو 10 بوصات). ترتبط منطقة Ribeye مباشرة بكمية العضلات في الذبيحة.",
    animalStatus:"حالة الحيوان في المزرعة على سبيل المثال: في المزرعة ، بيع ، نفوق ، إلخ"
  },
  manageAnimalGroupings: {
    resetModeTooltip: `, 
                                                                 وضع إعادة ضبط <br>, 
                                                                 في هذا الوضع <br>, 
                                                                 1) تعيين/تحديد جميع خصائص المجموعات المعاصرة (CGS) لجميع سمات الاهتمام. <br>, 
                                                                 2) تعيين جميع الحيوانات إلى CG المقابلة. <br>, 
                                                                 3) إذا كان تعيين الحيوانات غير مرضٍ  فقم بضبط/تغيير CGS  ثم تعيين الحيوانات مرة أخرى إلى CGS المقابلة الجديدة. <br>, 
                                                                 4) كرر الخطوات المذكورة أعلاه  إذا لزم الأمر  حتى تكون راضيًا عن CGS وتجميع/تعيين الحيوانات المقابلة. <br>, 
                                                                 `,
    maintainanceModeHeadingTooltip: `بمجرد الانتهاء من إعادة تعيين (الوضع)  ستدخل وضع الصيانة حيث سيتم الاحتفاظ بـ EDPs المحسوبة في إعادة تعيين ثابت لكل حيوان حتى إعادة التعيين التالية (والتي يمكن أن تكون على بعد 2-6 أشهر). علاوة على ذلك  فإن أي حيوانات جديدة تمت إضافتها إلى الحيوانات الموجودة بالفعل في النظام أثناء وضع الصيانة ستحسب EPDs من خلال طريقة أخرى  وهي طريقة أسلاف  حتى يتم إعادة حسابها في إعادة تعيينها التالية.`,
    maintainanceModeTooltip: `بعد إكمال وضع إعادة التعيين  اضغط على الزر النهائي لإعادة تعيين لتمكين النظام من حساب EPDs لجميع الحيوانات  وإنهاء وضع إعادة التعيين  وبدء وضع الصيانة.`,
    resetToggleTooltip: `تمكين إعادة تعيين تبديل في إعداد نموذج EPD لتعيين الحيوانات إلى CGS.`,
  },
  geneticsAndBreeding: {
    geneticsAndBreeding: "علم الوراثة",
    geneticSearchTool: "أداة البحث الجيني",
    dataSubmission: "تقديم البيانات",
    animalsWithExpectedProgenyDifferences:
      "الحيوانات مع الاختلافات المتوقعة في النسل (EPDs)",
    searchByAnimalIdName: "البحث عن طريق معرف الحيوان والاسم",
    rowsPerPage: "عدد الصفوف في الصفحة",
    individualEntry: "دخول فردي",
    bulkEntry: "الدخول بالجملة",
    registerANewAnimalOrSelectAnExistingAnimal:
      "سجل حيوانًا جديدًا أو اختر حيوانًا موجودًا.",
    registerNewAnimal: "Regsiter حيوان جديد",
    selectExistingAnimal: "حدد حيوان موجود",
    animalID: "معرف الحيوان",
    animalName: "اسم الحيوان",
    tag: "بطاقة شعار",
    dateOfBirth: "تاريخ الميلاد",
    gender: "جنس",
    birthDate: "تاريخ الميلاد",
    birthWeightLb: "الوزن عند الولادة (رطل)",
    birthWeightKg: "الوزن عند الولادة (كلغ)",
    weaningWeightLb: "وزن الفطام (رطل)",
    weaningWeightKg: "وزن الفطام (كجم)",
    yearlingWeightLb: "الوزن الشائع (رطل)",
    yearlingWeightKg: "الوزن السنوي (كلغ)",
    carcassWeightLb: "وزن الذبيحة (رطل)",
    carcassWeightKg: "وزن الذبيحة (كجم)",
    animalSelection: "اختيار الحيوان",
    animalSearchTool: "أداة البحث عن الحيوانات",
    back: "خلف",
    searchByEPDs: "البحث عن طريق EPDs",
    searchByIds: "البحث عن طريق المعرفات",
    selectBreed: "حدد سلالة",
    selectGender: "حدد نوع الجنس",
    selectRequiredBreedForCattle: "حدد السلالة المطلوبة للماشية",
    resetFilter: "تصفية إعادة تعيين",
    birthWeightHeader: "الوزن عند الولادة: ",
    birthWeightDef:
      "يقارن الفروق في وزن العجول عند الولادة ويقاس بالجنيه أو الكيلوغرام.",
    weaningWeightHeader: "وزن الفطام (WW): ",
    weaningWeightDef:
      "WW EPD هو تقدير لنمو ما قبل الفطام يتم قياسه بالجنيه أو كجم.",
    yearlingWeightHeader: "الوزن السنوي (YW): ",
    yearlingWeightDef:
      "YW EPD هو تقدير للنمو بعد الفطام يتم قياسه بالجنيه أو كجم.",
    ribEyeAreaHeader: "منطقة ريب آي (REA): ",
    ribEyeAreaDef:
      "يقيس REA حجم العضلات التي تعطينا الضلع بالبوصة المربعة. تعكس REA EPDs الاختلافات في قياس مساحة الضلع المعدلة لمدة 365 يومًا بناءً على قياسات الذبيحة للماشية المحصودة.",
    marblingHeader: "الرخام (MARB): ",
    marblingDef:
      "يتم قياس MARB EPD بوحدات النسبة المئوية للدهون العضلية داخل عين الضلع. تعكس MARB EPDs الاختلافات في درجة رخامية معدلة لمدة 365 يومًا (الدهون العضلية ، [IMF]) بناءً على قياسات الذبيحة للماشية المحصودة.",
    fatThicknessHeader: "سماكة الدهون (FAT): ",
    fatThicknessDef:
      "بوصة من الدهن العكسي (بالمئات من البوصة) هي وحدة قياس FT.",
    carcassWeightHeader: "وزن الذبيحة (CW): ",
    carcassWeightDef:
      "وزن الذبيحة هو سمة مفيدة عند النظر في تأثير الجنيهات بالنسبة لقيمة المنتج النهائي. ",
    yieldGradeHeader: "درجة الإنتاجية (YG): ",
    yieldGradeDef:
      "نظام تسجيل درجات العائد من وزارة الزراعة الأمريكية هو وحدة القياس الخاصة بـ YG EPD. ",
    milkHeader: "الحليب (MK): ",
    milkDef:
      "يتم قياس MK EPD بالجنيه من وزن فطام العجل نظرًا لقدرة والدته على الحلب.",
    totalMaternalHeader: "إجمالي الأمهات (TM): ",
    totalMaternalDef:
      "يقيس TM تأثيره على وزن فطام العجل بسبب إنتاج الحليب والجينات الوراثية للنمو.",
    calvingEaseDirectHeader: "إرخاء العجول المباشر (CED): ",
    calvingEaseDirectDef: "يتم سرد CED EPD كنسبة مئوية من العجول بدون مساعدة.",
    calvingEaseMaternalHeader: "ولادة سهولة الولادة (CEM): ",
    calvingEaseMaternalDef:
      "يقيس قدرة بنات الثور على العجول دون مساعدة عندما يبلغن من العمر عامين.",
    stayabilityHeader: "البقاء (STAY): ",
    stayabilityDef:
      'يتنبأ ST EPD بقدرة الثور على تربية الأبقار التي "تبقى حولها". ',
    docilityHeader: "الانقياد (DOC): ",
    docilityDef: "يقيس DOC مزاج الماشية.",
    max: "الأعلى",
    min: "دقيقة",
    accuracy: "دقة",
    sortBy: "ترتيب حسب",
    traits:
      "السمات المعروضة باللون الرمادي قيد التطوير ، وستأتي في الربع الثاني من عام 2023.",
    searchResults: "نتائج البحث",
    recordsFound: "وجدت السجلات",
    compareSelected: "قارن ما تم تحديده",
    animalIdentification: "تحديد الحيوان",
    errorMessage: {
      birthWeight:
        "لا يمكن أن تكون القيمة القصوى للوزن عند الولادة أقل من الحد الأدنى لوزن الولادة",
      weaningWeight:
        "لا يمكن أن تكون القيمة القصوى لوزن الفطام أقل من الحد الأدنى لوزن الفطام",
      yearlingWeight:
        "لا يمكن أن تكون القيمة القصوى للوزن السنوي أقل من الحد الأدنى للوزن السنوي",
      carcassWeight:
        "لا يمكن أن تكون القيمة القصوى لوزن الذبيحة أقل من الحد الأدنى لوزن الولادة",
      fatThickness:
        "لا يمكن أن تكون القيمة القصوى لسمك الدهون أقل من الحد الأدنى لوزن الفطام",
      marbling:
        "لا يمكن أن تكون القيمة القصوى للرخام أقل من الحد الأدنى للوزن السنوي",
      ribeyeArea:
        "لا يمكن أن تكون القيمة القصوى لمنطقة Ribeye Area أقل من الحد الأدنى لوزن الولادة",
      yieldGrade:
        "لا يمكن أن تكون القيمة القصوى لدرجة الإنتاجية أقل من الحد الأدنى لوزن الفطام",
      milk:
        "لا يمكن أن تكون القيمة القصوى للحليب أقل من الحد الأدنى لوزن الفطام",
    },
    reg: "ريج",
    name: "اسم",
    sex: "الجنس",
    tattoo: "وشم",
    dob: "DOB",
    EPD: "EPD",
    rank: "رتبة",
    searchValue: "قيمة البحث",
    typeHere: "أكتب هنا",
    searching: "يبحث...",
    fetchingResult: "إحضار النتائج ... الرجاء الانتظار",
    animalsMatchedYourCriteria: "تطابق الحيوانات معاييرك",
    manageAnimalsGrouping: "إدارة تجميع الحيوانات",
    manageAnimalGroupings: "إدارة تجمعات الحيوانات",
    assignAnimalToContemporaryGroups: "تخصيص الحيوان للمجموعات المعاصرة",
    resetMode: "إعادة الوضع",
    enterResetMode: "أدخل وضع إعادة التعيين",
    maintainanceMode: "وضع الصيانة",
    assigningAnimals: "تعيين الحيوانات",
    excludedAnimals: "الحيوانات المستبعدة",
    ungroupedAnimals: "الحيوانات غير المجمعة",
    assignAnimalsToCGS: "تعيين الحيوانات إلى CGS",
    reset: "إعادة ضبط",
    excludeAnimals: "استبعاد الحيوانات",
    resetToMaintainanceMode: "إعادة التعيين النهائي - التغيير إلى وضع الصيانة",
    contemporaryGroupsSettings: "إعدادات المجموعات المعاصرة (CG)",
    selectTrait: "حدد سمة",
    selectTraitDescription:"يشير تحديد سمة إلى عملية اختيار سمة معينة",
    traitsType: {
      birthWeight: "الوزن عند الولادة",
      weaningWeight: "وزن الفطام",
      yearlingWeight: "الوزن السنوي",
      carcassWeight: "وزن الذبيحة",
    },
    addNewGroup: "إضافة مجموعة جديدة",
    contemporaryGroup: "المجموعة المعاصرة",
    contemporaryGroups: "المجموعات المعاصرة",
    editGroup: "تحرير المجموعة",
    birthCGCode: "قانون الميلاد (CG)",
    groupName: "أسم المجموعة",
    birthSex: "الجنس عند الولادة",
    conceptionMethod: "طريقة الحمل",
    weaningCGCode: "قانون الفطام (CG)",
    yearlingCGCode: "رمز سن سنة (CG)",
    dateWeight: "وزن التاريخ",
    weaningyearlingCGcode: "الفطام / سن سنة (CG)",
    carcassCGCode: "كود الذبيحة (CG)",
    breedOfDom: "سلالة دوم",
    addNewContemporaryGroup: "إضافة مجموعة معاصرة جديدة",
    createNewGroup: "إنشاء مجموعة جديدة",
    selectFromDifferentTraits: "اختر من بين السمات المختلفة",
    contemporaryGroupName: "اسم المجموعة المعاصرة",
    enterNameHere: "أدخل الاسم هنا",
    groupNameIsRequired: "اسم المجموعة مطلوب",
    birthYearRange: "نطاق سنة الميلاد",
    theYearAnimalWasBorn: "سنة ولد الحيوان",
    birthYearIsRequired: "سنة الميلاد مطلوبة",
    genderOfNewBornAnimal: "جنس الحيوان حديث الولادة",
    selectSex: "حدد الجنس",
    theweightOfAnimalAtBirth: "وزن الحيوان عند الولادة",
    maximumKg: "الحد الأقصى (كجم)",
    minimumKg: "الحد الأدنى (كجم)",
    aSeasonisAPeriodOfYear: "الموسم فترة من العام تتميز بظروف مناخية خاصة.",
    seasonofBirthIsRequired: "مطلوب موسم الميلاد",
    majorGenericContributionOfAnimal: "المساهمة العامة الرئيسية٪ للحيوان",
    primaryBreedCompostionIsRequired: "مطلوب سماد السلالة الأولية",
    secondaryBreedCompostionIsRequired: "مطلوب سماد سلالة ثانوية",
    howTheAnimalWasConceived:
      "كيف تم تصور الحيوان (التزاوج الطبيعي / التلقيح / نقل الأجنة)",
    conceptionMethodIsRequired: "طريقة الحمل مطلوبة",
    epdModelSettings: "إعدادات نموذج EPD",
    forResetMode: "لوضع إعادة التعيين",
    progenyWeightingFactor: "عامل وزن النسل",
    weightGivenToTheProgenyFactor:
      "الوزن المعطى لعامل النسل بالنسبة لعامل CG لحساب EPD في وضع إعادة التعيين. ",
    enterNumber: "أدخل رقم",
    enterBreed: "أدخل السلالة",
    valueShouldBeBetween0and1: "يجب أن تكون القيمة بين 0 و 1",
    resetDuration: "إعادة تعيين المدة",
    timeIntervalBetweenLastAndFirstResetMode:
      "الفاصل الزمني بين وضع إعادة التعيين الأخير والجديد ، وفي نهايته يتم تمكين وضع إعادة التعيين الجديد ويتم حساب CGs و EPDs الجديدة.",
    enterNumberOfDays: "أدخل عدد الأيام",
    valueCannotBeNegative: "لا يمكن أن تكون القيمة سالبة!",
    criticalProgenyPopulation: "السكان ذرية الحرجة",
    minimumNumberOfProgenyRecords:
      "الحد الأدنى لعدد سجلات النسل للحيوان الفردي في النظام الضروري لتحقيق دقة النسل (APD1) أعلى من 50٪ (لدقة النسب)",
    criticalAncestorPopulation: "السكان السلف الحرج",
    minimumNumberOfAncestorsRecords:
      "الحد الأدنى لعدد سجلات أسلاف الحيوان الفردي في النظام ضروري لتحقيق دقة أسلاف (APD4) أعلى من 50٪ (لدقة النسب)",
    forBirthWeightCG: "لوزن الولادة CG",
    criticalPopulationInAnimalsContemporaryGroup:
      "السكان الحرجون في مجموعة الحيوانات المعاصرة",
    minimumAverageNumberOfAnimalsPerBirthWeight:
      "الحد الأدنى لمتوسط ​​عدد الحيوانات لكل مولود وزن CG ضروري لتحقيق متوسط ​​دقة CG (ACG3) أعلى من 50٪",
    criticalAveragePopulationPerContemporaryGroup:
      "متوسط ​​عدد السكان الحرج لكل مجموعة معاصرة",
    minimumNumberOfAnimalsInBirthWeight:
      "الحد الأدنى لعدد الحيوانات في الوزن عند الولادة للحيوان ضروري لتحقيق دقة CG (ACG2) أعلى من 50٪",
    forWeaningWeightCG: "لفطام الوزن CG",
    minimumAverageNumberOfAnimalsPerWeaningWeight:
      "الحد الأدنى لمتوسط ​​عدد الحيوانات لكل وزن فطام CG ضروري لتحقيق متوسط ​​دقة CG (ACG3) أعلى من 50٪",
    minimumNumberOfAnimalsInWeaningWeight:
      "الحد الأدنى لعدد الحيوانات في وزن الفطام للحيوان CG ضروري لتحقيق دقة CG (ACG2) أعلى من 50٪",
    forYearlingWeightCG: "لوزن عام CG",
    minimumAverageNumberOfAnimalsPerYearling:
      "الحد الأدنى لمتوسط ​​عدد الحيوانات لكل CG ضروري لتحقيق متوسط ​​دقة CG (ACG3) أعلى من 50٪",
    minimumNumberOfAnimalsInYearlingWeight:
      "الحد الأدنى لعدد الحيوانات في CG للوزن السنوي للحيوان ضروري لتحقيق دقة CG (ACG2) أعلى من 50٪",
    forCarcassCG: "للحصول على Carcass CG",
    minimumAverageNumberOfAnimalsPerCarcassWeight:
      "الحد الأدنى لمتوسط ​​عدد الحيوانات لكل ذبيحة وزن CG ضروري لتحقيق متوسط ​​دقة CG (ACG3) أعلى من 50٪",
    minimumNumberOFAnimalInCarcassWeight:
      "الحد الأدنى لعدد الحيوانات في وزن ذبيحة الحيوان CG ضروري لتحقيق دقة CG (ACG2) أعلى من 50٪",
    epdRequiredFieldSettings: "إعدادات الحقول المطلوبة EPD",
    pleaseSelectRequiredFieldsForCompleteEPD:
      "يرجى تحديد الحقول المطلوبة لحساب EPD الكامل",
    byDefault: "بشكل افتراضي",
    pleaseNoteThatUsersNotAbleToObtainFullEPD:
      "ملاحظة: يرجى ملاحظة أن المستخدمين لن يتمكنوا من الحصول على حساب EPD الكامل إذا لم يقدموا حقول البيانات التي تحددها على أنها مطلوبة.",
    pleaseNoteThatRequiredFieldParametersCannotBeChanged:
      "ملاحظة: يرجى ملاحظة أنه لا يمكن تغيير معلمات الحقول المطلوبة نظرًا لوجود مجموعات معاصرة بالفعل مقابل المعلمات السابقة.",
    noResultFound: "لم يتم العثور على نتائج",
    next: "التالي",
    cancel: "يلغي",
    selectAnimal: "حدد حيوان",
    searchBy: "البحث عن طريق",
    breed: "تكاثر",
    regDate: "ريج. ",
    status: "حالة",
    animalDetails: "تفاصيل الحيوان",
    add: "يضيف",
    update: "تحديث",
    dataForEPDs: " بيانات EPD",
    basicInformation: "معلومات اساسية",
    birthWeightInformation: "معلومات الوزن عند الولادة",
    weaningWeightInformation: "معلومات وزن الفطام",
    yearlingWeightInformation: "معلومات الوزن السنوي",
    carcassWeightInformation: "معلومات وزن الذبيحة",
    delete: "يمسح",
    deleteEpdData: "حذف بيانات EPD",
    areYouSureYouWantToDeleteEpdData: "هل أنت متأكد أنك تريد حذف بيانات EPD.",
    internationalID: "الهوية الدولية",
    enterID: "أدخل المعرف",
    animalRegistration: "تسجيل الحيوانات",
    location: "موقع",
    additionalIDMethod: "طريقة معرف إضافية",
    damID: "معرف السد",
    sireID: "معرف الأب",
    breederHerdCode: "رمز قطيع المربي",
    birthYear: "سنة الميلاد",
    primaryBreed: "السلالة الأولية",
    breedComposition: "تكوين السلالة",
    secondaryBreed: "سلالة ثانوية",
    seasonofBirth: "موسم الميلاد",
    birthManagementCode: "قانون إدارة الولادة",
    damAge: "ضرر",
    years: "سنين",
    birthContemporaryCode: "قانون الميلاد المعاصر",
    accuracyWeight: "وزن الدقة",
    noteMinimumRequiredFieldForBirthWeight:
      "ملحوظة: حقل أدنى إلزامي للوزن عند الولادة ، EPDs ، سنة الميلاد ، الجنس ، طريقة الحمل ، الوزن عند الولادة.",
    note: "ملحوظة",
    minimumRequiredFieldForBirthWeight:
      "الحد الأدنى للحقل المطلوب لملفات EPD للوزن عند الولادة",
    birthYearGenderConceptionMethodBirthWeight:
      "سنة الميلاد ، الجنس ، طريقة الحمل ، الوزن عند الميلاد",
    weaningWeight: "وزن الفطام",
    weaningDate: "تاريخ الفطام",
    weaningContemporaryGroupCode: "الفطام كود المجموعة المعاصرة",
    creep: "زحف",
    managementPastureCode: "كود الإدارة / المرعى",
    weaningSex: "الفطام عن الجنس",
    minimumRequiredFieldForWeaningWeight:
      "الحد الأدنى من الحقل المطلوب لملفات EPD الخاصة بوزن الفطام",
    weaningWeightManagementPastureCodeWeaningSexDateWeighed:
      "وزن الفطام ، الإدارة / كود المرعى ، جنس الفطام ، وزن التمر",
    yearlingWeight: "الوزن عند عمر سنة",
    yearlingHeight: "ارتفاع عام",
    yearlingDate: "تاريخ سنة",
    yearlingContemporaryGroupCode: "رمز المجموعة المعاصرة السنوية",
    managementFeedingCode: "كود الإدارة / التغذية",
    yearlingSex: "الجنس عام",
    youWillNeedToFillOutFor:
      "ستحتاج إلى ملء جميع الحقول لاسترداد بيانات EPD لـ",
    pleaseSelectHavestDateFirstToEnterInfo:
      'يرجى تحديد "تاريخ الحصاد" أولاً لإدخال معلومات منطقة عين الضلع وسمك الدهون والرخامي',
    harvestDate: "تاريخ الحصاد",
    dateOnFeed: "التاريخ على الأعلاف",
    daysOnFeed: "أيام على الخلاصة",
    gradingDate: "تاريخ التقدير",
    carcassSex: "الجنس الذبيحة",
    carcassWeight: "وزن الذبيحة",
    carcassContemporary: "الذبيحة المعاصرة",
    damBreed: "تكاثر السد",
    ribEyeArea: "منطقة ضلع العين",
    ribEyeAreaContemporary: "منطقة ريب آي معاصرة",
    fatThickness: "سماكة الدهون",
    fatThicknessContemporary: "سماكة الدهون المعاصرة",
    marbling: "رخامي",
    marblingContemporary: "رخامي معاصر",
    yieldGradeContemporary: "إنتاجية معاصرة",
    animalsNotListedInContemporaryGroupsMsg:
      "لم تتم إضافة الحيوانات إلى أي مجموعات معاصرة بسبب نقص المعلومات. ",
    listOfUngroupedAnimals: "قائمة الحيوانات غير المجمعة",
    submittingData: "تقديم البيانات",
    resendToUser: "إعادة الإرسال إلى المستخدم",
    submittingAnimalsInGroupMsg: "وضع حيواناتك في مجموعات. ",
    pressingResetBtnMsg:
      'سيؤدي الضغط على زر "إعادة تعيين" إلى بدء عملية إعادة تعيين الحيوانات لمجموعاتها المعاصرة.',
    doYouWantToProceed: "هل تريد المتابعة ؟",
    systemMaintainanceModeMsg:
      'سيؤدي الضغط على زر "التغيير إلى وضع الصيانة" إلى بدء العملية وسيدخل نظامك إلى "وضع الصيانة" حيث ستظل EDP المحسوبة في RESET ثابتة لكل حيوان حتى إعادة الضبط التالية (والتي قد تكون من 1 إلى 6 أشهر ',
    errorFetchingContemporaryGrpMsg: "خطأ في جلب بيانات المجموعة المعاصرة",
    deleteSuccess: "حذف النجاح",
    deleteSuccessMsg: "تم حذف المجموعة المعاصرة بنجاح.",
    deleteFailed: "فشل الحذف",
    deleteFailedMsg: "خطأ في حذف بيانات المجموعة المعاصرة",
    deleteContemporaryGrpMsg:
      "هل أنت متأكد أنك تريد حذف هذه المجموعة المعاصرة؟",
    addBirthWeightData: "إضافة بيانات الوزن عند الولادة",
    addWeaningWeightData: "أضف بيانات وزن الفطام",
    birthWeightContemporaryGroupCode: "وزن الميلاد المعاصر رمز المجموعة",
    dateWeighted: "تاريخ مرجح",
    addYearlingWeightData: "أضف بيانات الوزن السنوي",
    addCarcassWeightData: "أضف بيانات وزن الذبيحة",
    weaningOrYearlingContemporaryGroupCode:
      "الفطام أو الوزن السنوي للمجموعة المعاصرة",
    deleteContemporaryGroupMsg: "هل أنت متأكد أنك تريد حذف المجموعة المعاصرة؟",
    updateSuccessMsg: "تم تحديث المجموعة المعاصرة بنجاح.",
    errorMsg: "هناك خطأ ما. ",
    fetchErrorMsg: "خطأ في جلب الحقول المطلوبة للسمة المختارة.",
    forMaintainanceMode: "لوضع الصيانة",
    ancestorsWeightFactor: "عامل وزن الأجداد",
    weightGivenToTheAncestorFactor:
      "الوزن المعطى لعامل السلف بالنسبة لعامل CG لحساب EPD في وضع الصيانة. ",
    addEPDModelSettingsData: "إضافة بيانات إعدادات نموذج EPD",
    minimumNumberOfAnimalsInContemporaryGroups:
      "الحد الأدنى لعدد الحيوانات في المجموعات المعاصرة",
    enterNumberOfAnimals: "أدخل عدد الحيوانات",
    areYouSureYouWantToChangeEPDCalculation:
      "هل أنت متأكد أنك تريد تغيير حقول حسابات EPD المطلوبة؟",
    weightOfAnimalAtBirth: "وزن الحيوان عند الولادة",
    seasonIsAPeriodOfYear: "الموسم فترة من العام تتميز بظروف مناخية خاصة.",
    codeOfBirthWeightContemporaryGroup:
      "قانون مجموعة الوزن عند الولادة المعاصرة",
    weaningWeightOfCalf: "وزن فطام العجل",
    dateAnimalWasWeaned: "تاريخ فطام الحيوان",
    genderOfWeaningAnimal: "جنس حيوان الفطام",
    yearlingWeightOfCalf: "وزن العجل عند سن سنة",
    dateAnimalWasWeighted: "تاريخ وزن الحيوان",
    yearledAnimalSex: "جنس الحيوان الذي كان عمره سنة",
    dateOfAnimalKilledForMeat: "تاريخ ذبح الحيوان من أجل اللحم",
    addSuccessMsg: "تمت إضافة المجموعة المعاصرة بنجاح",
    traitH: "سمة حساب EPD",
    searchByValue: "أدخل رقم التسجيل / الوشم / الاسم / العلامة"
  },
};
